
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kA4n2", function(module, exports) {

$parcel$export(module.exports, "AppNavigation", () => $74e335de313f2b62$export$140c5c8fcbe43661);
/*eslint-disable @atlaskit/design-system/no-unsafe-style-overrides */ 
var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $3WBvo = parcelRequire("3WBvo");

var $XLQOT = parcelRequire("XLQOT");

var $irVI7 = parcelRequire("irVI7");
var $1eaCJ = parcelRequire("1eaCJ");

var $b8XTE = parcelRequire("b8XTE");

var $eSLr0 = parcelRequire("eSLr0");
var $6ld6a = parcelRequire("6ld6a");

var $gLUd5 = parcelRequire("gLUd5");

var $d9tcB = parcelRequire("d9tcB");
var $dHe7o = parcelRequire("dHe7o");

var $1ytiN = parcelRequire("1ytiN");

var $kVysQ = parcelRequire("kVysQ");
var $4NX9d = parcelRequire("4NX9d");

var $lBYCH = parcelRequire("lBYCH");

var $8w1c1 = parcelRequire("8w1c1");

var $hFfmQ = parcelRequire("hFfmQ");

var $luv00 = parcelRequire("luv00");

var $9wGTI = parcelRequire("9wGTI");

var $c5zvz = parcelRequire("c5zvz");

var $60A3u = parcelRequire("60A3u");

var $egliE = parcelRequire("egliE");

var $bnz0d = parcelRequire("bnz0d");

var $dGn84 = parcelRequire("dGn84");

var $7pjFz = parcelRequire("7pjFz");

var $34WJV = parcelRequire("34WJV");
const $74e335de313f2b62$var$i18n = (0, $2nPZH.defineMessages)({
    navRegionLabel: {
        id: "app-navigation.navigation.region.aria.label",
        defaultMessage: "Global"
    },
    moreLabel: {
        id: "app-navigation.more.dropdown.label",
        defaultMessage: "More"
    }
});
const $74e335de313f2b62$var$EmptyItem = ()=>null;
const $74e335de313f2b62$var$noop = ()=>{};
const $74e335de313f2b62$var$AppNavigationComponent = ({ theme: theme, homepageUri: homepageUri, homepageTitle: homepageTitle, webItems: webItems, isLimitedNav: isLimitedNav })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { primaryItems: primaryItems } = (0, $60A3u.usePrimaryItems)({
        customHomepage: {
            homepageUri: homepageUri,
            homepageTitle: homepageTitle
        },
        webItems: webItems
    });
    const { isLoggedIn: isLoggedIn, isRovoEnabled: isRovoEnabledSessionData, isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus } = (0, $dHe7o.useSessionDataWithRovoExperiment)();
    const shouldShowRovo = (0, $9wGTI.fg)('rovo_use_rovo_llm_enabled_check') ? isRovoLLMEnabled : isRovoEnabledSessionData;
    const isRovoEnabled = shouldShowRovo && isLoggedIn && accessStatus !== (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
    const isNotesEnabled = isLoggedIn && (0, $9wGTI.fg)('confluence_notes');
    /* react/function-component-definition */ const RenderNotifications = (0, $gwFzn.useMemo)(()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, isRovoEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hFfmQ.ConversationAssistantNavBarButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hFfmQ.RovoEntitlementSetter), {
                isRovoEnabled: isRovoEnabled
            }), isNotesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7pjFz.LazyNotes), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7pjFz.LazyNotifications), null)), [
        isRovoEnabled,
        isNotesEnabled
    ]);
    const RenderSearch = (0, $gwFzn.useMemo)(()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $XLQOT.EditionAwareness), null), (0, $9wGTI.fg)('edition_awareness_standard_upsell_confluence_ab_fg') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c5zvz.EditionAwarenessUpsellExperiment), {
                navVersion: "nav3"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7pjFz.LazySearch), {
                theme: theme && theme.mode.search
            })), [
        theme
    ]);
    /* eslint-enable react/no-unstable-nested-components, react/function-component-definition */ const RenderMoreLabel = (0, $gwFzn.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $74e335de313f2b62$var$i18n.moreLabel), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-vc": "app-navigation-base",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3WBvo.AtlassianNavigation), {
        moreLabel: RenderMoreLabel,
        renderAppSwitcher: (0, $7pjFz.LazyAppSwitcher),
        renderCreate: isLimitedNav ? $74e335de313f2b62$var$EmptyItem : (0, $7pjFz.LazyCreate),
        renderHelp: (0, $7pjFz.LazyHelp),
        renderNotifications: isLimitedNav ? $74e335de313f2b62$var$EmptyItem : RenderNotifications,
        renderProfile: (0, $7pjFz.LazyProfile),
        renderSettings: isLimitedNav ? $74e335de313f2b62$var$EmptyItem : (0, $7pjFz.LazySettings),
        primaryItems: isLimitedNav ? [] : primaryItems,
        renderProductHome: (0, $bnz0d.ConfluenceProductHome),
        renderSearch: isLimitedNav ? $74e335de313f2b62$var$EmptyItem : RenderSearch,
        theme: theme,
        label: formatMessage($74e335de313f2b62$var$i18n.navRegionLabel)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.APP_NAV_GLOBAL_EXPERIENCE),
        attributes: {
            navVersion: '3'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b8XTE.PageSegmentLoadEnd), {
        metric: (0, $8w1c1.APP_NAVIGATION_METRIC),
        customData: {
            isAnonymous: !isLoggedIn
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4NX9d.PerformanceEnd), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigation),
        subjectId: "NavigationLoading",
        includeFeatureFlags: true,
        details: $74e335de313f2b62$var$nav3Details
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4NX9d.PerformanceEnd), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigationFMP),
        subjectId: "NavigationFMP",
        includeFeatureFlags: true,
        details: $74e335de313f2b62$var$nav3Details
    }));
};
const $74e335de313f2b62$export$140c5c8fcbe43661 = /*#__PURE__*/ (0, $gwFzn.memo)((props)=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { isLimitedNav: isLimitedNav = false } = props;
    const { loading: viewContextLoading, homepageUri: homepageUri, homepageTitle: homepageTitle } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const { loading: themeLoading, theme: theme } = (0, $egliE.useNavigationTheme)();
    const resetStickySearchRef = (0, $gwFzn.useRef)($74e335de313f2b62$var$noop);
    const profileMenuButtonRef = (0, $gwFzn.useRef)(null);
    const primaryDropdownItemRef = (0, $gwFzn.useRef)(null);
    const createContentPopoverButtonRef = (0, $gwFzn.useRef)(null);
    const { loading: webItemsLoading, webItems: webItems } = (0, $6ld6a.useWebItemLocation)({
        location: (0, $eSLr0.SYSTEM_HEADER_LEFT),
        allowedWebItems: [
            (0, $dGn84.SPACE_DIRECTORY_KEY),
            (0, $dGn84.PEOPLE_DIRECTORY_KEY)
        ]
    });
    const appNavigationContextValue = (0, $gwFzn.useMemo)(()=>({
            isBranchDeploy: (0, $gLUd5.isBranchDeployFn)(),
            theme: theme,
            resetStickySearchRef: resetStickySearchRef,
            profileMenuButtonRef: profileMenuButtonRef,
            primaryDropdownItemRef: primaryDropdownItemRef,
            createContentPopoverButtonRef: createContentPopoverButtonRef
        }), [
        theme,
        resetStickySearchRef,
        profileMenuButtonRef,
        primaryDropdownItemRef,
        createContentPopoverButtonRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lBYCH.AppNavigationContext).Provider, {
        value: appNavigationContextValue
    }, viewContextLoading || themeLoading || webItemsLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $34WJV.NavSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($74e335de313f2b62$var$AppNavigationComponent, {
        theme: theme,
        homepageUri: homepageUri,
        homepageTitle: homepageTitle,
        webItems: webItems,
        isLimitedNav: isLimitedNav,
        ...ssrPlaceholderIdProp
    }));
});
const $74e335de313f2b62$var$nav3Details = {
    navVersion: '3'
};

});
parcelRegister("60A3u", function(module, exports) {

$parcel$export(module.exports, "usePrimaryItems", () => $01ddbb7cc73fd164$export$457cd0e86c25f865);

var $gwFzn = parcelRequire("gwFzn");

var $d9tcB = parcelRequire("d9tcB");
var $bQm3c = parcelRequire("bQm3c");

var $jmjWc = parcelRequire("jmjWc");

var $jyPfN = parcelRequire("jyPfN");

var $7CeAz = parcelRequire("7CeAz");

var $cEgMD = parcelRequire("cEgMD");

var $dGn84 = parcelRequire("dGn84");

var $diQpe = parcelRequire("diQpe");

var $cEWom = parcelRequire("cEWom");

var $6CulZ = parcelRequire("6CulZ");

var $f5yOH = parcelRequire("f5yOH");

var $k4ueP = parcelRequire("k4ueP");

var $2idHG = parcelRequire("2idHG");

var $a8e7z = parcelRequire("a8e7z");

const $01ddbb7cc73fd164$var$CustomHomepageItemLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iskdI",
    name: "CustomHomepageItemLoader",
    loader: async ()=>(await (parcelRequire("jSBj7"))).CustomHomepageItem
});
const $01ddbb7cc73fd164$export$457cd0e86c25f865 = ({ customHomepage: customHomepage, webItems: webItems })=>{
    const { isLicensed: isLicensed, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const { isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled } = (0, $7CeAz.useIsCompanyHubEnabled)();
    const isHomeHidden = !isLicensed || accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).UNLICENSED_AUTHENTICATED_ACCESS;
    const isSpacesHidden = !webItems.find((item)=>item.completeKey === (0, $dGn84.SPACE_DIRECTORY_KEY));
    const isPeopleHidden = !hasViewUserProfilePermission || !webItems.find((item)=>item.completeKey === (0, $dGn84.PEOPLE_DIRECTORY_KEY));
    const hideCustomHomepageItem = (0, $gwFzn.useMemo)(()=>{
        // If Company Hub is the custom homepage, suppress this link item in
        // the nav bar, because it will duplicate the custom Company Hub link
        // we already show
        return customHomepage.homepageUri.includes((0, $cEgMD.getCompanyHubSpaceKey)()) || [
            '/spa.action',
            '',
            'homepageUri'
        ].includes(customHomepage.homepageUri);
    }, [
        customHomepage
    ]);
    const memoCustomHomePageItem = (0, $gwFzn.useMemo)(()=>{
        return customHomepage && !hideCustomHomepageItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($01ddbb7cc73fd164$var$CustomHomepageItemLoader, {
            key: "custom-homepage",
            testId: "app-navigation-primary-custom-home",
            href: customHomepage.homepageUri,
            label: customHomepage.homepageTitle
        }) : null;
    }, [
        customHomepage,
        hideCustomHomepageItem
    ]);
    const memoPrimaryItems = (0, $gwFzn.useMemo)(()=>{
        return [
            memoCustomHomePageItem,
            isCompanyHubEntryPointEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $diQpe.CompanyHubItem), {
                key: "company-hub"
            }) : null,
            !isHomeHidden ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cEWom.HomeItem), {
                key: "home",
                testId: "app-navigation-primary-home",
                pendoId: "con-*/wiki/home-home"
            }) : null,
            isLicensed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $f5yOH.PagesItem), {
                key: "pages",
                testId: "app-navigation-primary-pages"
            }) : null,
            !isSpacesHidden ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6CulZ.SpacesItem), {
                key: "spaces",
                testId: "app-navigation-primary-spaces",
                pendoId: "con-*/wiki/home-spaces"
            }) : null,
            !isPeopleHidden ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $k4ueP.PeopleItem), {
                key: "people",
                testId: "app-navigation-primary-people"
            }) : null,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2idHG.AppsItem), {
                key: "apps",
                testId: "app-navigation-primary-apps"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $a8e7z.TemplatesItem), {
                key: "templates",
                testId: "app-navigation-primary-templates"
            })
        ].filter((item)=>item !== null);
    }, [
        memoCustomHomePageItem,
        isCompanyHubEntryPointEnabled,
        isHomeHidden,
        isLicensed,
        isSpacesHidden,
        isPeopleHidden
    ]);
    return (0, $gwFzn.useMemo)(()=>({
            primaryItems: memoPrimaryItems
        }), [
        memoPrimaryItems
    ]);
};

});
parcelRegister("dGn84", function(module, exports) {

$parcel$export(module.exports, "SPACE_DIRECTORY_KEY", () => $019aa0a7f02759cb$export$8fa81f0104234d32);
$parcel$export(module.exports, "PEOPLE_DIRECTORY_KEY", () => $019aa0a7f02759cb$export$78f3e9dc1aa1d31d);
const $019aa0a7f02759cb$export$8fa81f0104234d32 = 'com.atlassian.confluence.plugins.confluence-space-ia:header-spaces-link';
const $019aa0a7f02759cb$export$78f3e9dc1aa1d31d = 'com.atlassian.confluence.plugins.confluence-space-ia:header-people-link';

});

parcelRegister("diQpe", function(module, exports) {

$parcel$export(module.exports, "CompanyHubItem", () => $f273da4cbc6fe515$export$7d5e579a7612f1c2);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $bWLcG = parcelRequire("bWLcG");

var $lBYCH = parcelRequire("lBYCH");

var $9wGTI = parcelRequire("9wGTI");

var $7O4kd = parcelRequire("7O4kd");

var $1ytiN = parcelRequire("1ytiN");

var $kAra1 = parcelRequire("kAra1");
/* Revisit styles when transition from site title to space name is done https://hello.jira.atlassian.cloud/browse/CTE-3671 */ const $f273da4cbc6fe515$var$companyHubItemStyles = (0, $ecnYn.xcss)({
    display: 'none',
    [(0, $bWLcG.media).above.md]: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
});
const $f273da4cbc6fe515$var$highlightStyles = (isHighlightedBorderColor, isHighlighted)=>(0, $ecnYn.xcss)({
        borderTopColor: 'transparent',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderBottomColor: isHighlighted ? `${isHighlightedBorderColor}` : 'transparent',
        borderBlockWidth: 'border.width.indicator',
        borderBlockStyle: 'solid'
    });
const $f273da4cbc6fe515$export$7d5e579a7612f1c2 = ()=>{
    const { frontCoverState: frontCoverState, loading: loading } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const { theme: theme } = (0, $gwFzn.useContext)((0, $lBYCH.AppNavigationContext));
    if (loading || !frontCoverState) return null;
    const isHighlightedBorderColor = theme?.mode.primaryButton.selected.borderColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7O4kd.AbstractCompanyHubItem), {
        navVersion: "3"
    }, ({ companyHubName: companyHubName, isSelected: isSelected, namedRoute: namedRoute, onClick: onAbstractCompanyHubItemClick })=>{
        let onPrimaryItemClick;
        if (namedRoute && (0, $9wGTI.fg)('company-hub-pseudo-app')) {
            // `PrimaryItem` opens the link via `RoutesContext` and doesn't support `target`.
            // Preempt `PrimaryItem` by not giving it the link's href `namedRoute`.
            // Then we have to open the link ourselves.
            const url = namedRoute.toUrl();
            namedRoute = undefined;
            onPrimaryItemClick = (e)=>{
                onAbstractCompanyHubItemClick();
                if (!e.isDefaultPrevented()) {
                    e.preventDefault();
                    window.open(url, '_blank', 'noreferrer'); // PrimaryItem opens the link like this
                }
            };
        } else onPrimaryItemClick = onAbstractCompanyHubItemClick;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            xcss: [
                $f273da4cbc6fe515$var$companyHubItemStyles,
                $f273da4cbc6fe515$var$highlightStyles(isHighlightedBorderColor, isSelected)
            ],
            ...isSelected && {
                testId: 'highlightContainer'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kAra1.PrimaryItem), {
            testId: "app-navigation-company-hub-item",
            isHighlighted: false,
            label: companyHubName,
            namedRoute: namedRoute,
            onClick: onPrimaryItemClick
        }));
    });
};

});
parcelRegister("kAra1", function(module, exports) {

$parcel$export(module.exports, "PrimaryItem", () => $1751d82a109faf5a$export$1ce843070047d7c1);
/* PrimaryItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $4jR19 = parcelRequire("4jR19");

var $3gadb = parcelRequire("3gadb");

var $56M4r = parcelRequire("56M4r");

var $1NxpI = parcelRequire("1NxpI");
var $aJmpt = parcelRequire("aJmpt");

var $7zgzO = parcelRequire("7zgzO");

var $ljm2R = parcelRequire("ljm2R");

var $lBYCH = parcelRequire("lBYCH");

var $eainP = parcelRequire("eainP");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1751d82a109faf5a$var$PrimaryButtonWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visitedcolor: visitedcolor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ih6qao": (0, $iAWao.default)(__cmplp.visitedcolor)
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_10pb1osq",
            __cmplp.visitedcolor ? "_1cayju3j" : "_1cay1wug",
            __cmplp.className
        ])
    });
});
const $1751d82a109faf5a$export$1ce843070047d7c1 = /*#__PURE__*/ (0, $gwFzn.memo)(({ testId: testId, i18n: i18n, label: label, namedRoute: namedRoute, onClick: onClick, href: href, keyboardShortcut: keyboardShortcut, deprecatedKeyboardShortcut: deprecatedKeyboardShortcut, isHighlighted: isHighlighted, isAppNavigationShortcut: isAppNavigationShortcut, pendoId: pendoId, keyboardShortcutString: keyboardShortcutString })=>{
    const { push: push, location: location, open: open } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const { isVisible: isVisible } = (0, $aJmpt.useOverflowStatus)();
    const { theme: theme } = (0, $gwFzn.useContext)((0, $lBYCH.AppNavigationContext));
    const [areKeyboardShortcutsEnabled] = (0, $ljm2R.useKeyboardShortcutsState)();
    const url = href || namedRoute && namedRoute.toUrl() || '';
    const clickCallback = (0, $gwFzn.useCallback)((e)=>{
        onClick && onClick(e);
        e.preventDefault();
        if (e.metaKey) url && open(url, '_blank', 'noreferrer');
        else url && push(url);
    }, [
        open,
        push,
        onClick,
        url
    ]);
    const buttonProps = {
        onClick: clickCallback,
        href: url,
        isHighlighted: isHighlighted !== undefined ? isHighlighted : !!location && url === location.pathname
    };
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
        "data-testid": testId,
        "data-pendo-id": pendoId
    }, label || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), i18n));
    const expandedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($1751d82a109faf5a$var$PrimaryButtonWrapper, {
        visitedcolor: theme && theme.mode.primaryButton.default.color
    }, !!keyboardShortcutString && areKeyboardShortcutsEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1NxpI.PrimaryButton), buttonProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutVisualizer), {
            shortcut: keyboardShortcutString,
            isTooltip: true
        })
    }, content)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1NxpI.PrimaryButton), buttonProps, content));
    const collapsedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eainP.PrimaryItemWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $56M4r.default), {
        onClick: clickCallback
    }, content));
    const onShortcutPressed = ()=>{
        url && push(url);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, isVisible ? expandedButton : collapsedButton, keyboardShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
        deprecatedAccelerator: deprecatedKeyboardShortcut,
        accelerator: keyboardShortcut,
        listener: onShortcutPressed,
        isAppNavigationShortcut: isAppNavigationShortcut || false
    }));
});

});
parcelRegister("eainP", function(module, exports) {

$parcel$export(module.exports, "NavItemWrapper", () => $f64e7d61e345676d$export$896707ae5a4e6569);
$parcel$export(module.exports, "UnstyledPopupLink", () => $f64e7d61e345676d$export$9e0789dbc75ca5e);
$parcel$export(module.exports, "HomeLogo", () => $f64e7d61e345676d$export$d5648119d5b68e90);
$parcel$export(module.exports, "PrimaryItemWrapper", () => $f64e7d61e345676d$export$6bf9c482c5610a58);
/* presentationalComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $8lYIw = parcelRequire("8lYIw");
const $f64e7d61e345676d$export$896707ae5a4e6569 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $f64e7d61e345676d$export$95c31692345d16c2 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = (0, $8lYIw.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _4cvr1h6o _syaz1kw7 _1nrm18uv _1a3b18uv _9oik18uv _1ydc18uv _c2waglyw _4fprglyw _1bnxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _1726nqa1 _1q5t1r31 _nt751r31 _1dit1r31 _9nxe1r31 _1ohyglyw _49pcglyw _ksodglyw _tpgfglyw _1r9xidpf _1hvwidpf _4hz8idpf _12gridpf _9h8h1kw7 _f8pj1kw7 _30l31kw7 _10531kw7",
            __cmplp.className
        ])
    });
});
const $f64e7d61e345676d$export$9e0789dbc75ca5e = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = $f64e7d61e345676d$export$95c31692345d16c2, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1bah1y6m",
            __cmplp.className
        ])
    });
});
const $f64e7d61e345676d$export$d5648119d5b68e90 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $f64e7d61e345676d$export$6bf9c482c5610a58 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_syaz1fxt _1e0c1txw",
            __cmplp.className
        ])
    });
});

});



parcelRegister("cEWom", function(module, exports) {

$parcel$export(module.exports, "HomeItem", () => $7b518c1026e9fbcc$export$40d01d2a751930be);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");

var $inPa6 = parcelRequire("inPa6");

var $dPJCf = parcelRequire("dPJCf");

var $1NBp8 = parcelRequire("1NBp8");

var $lBYCH = parcelRequire("lBYCH");

var $epLE5 = parcelRequire("epLE5");

var $ljm2R = parcelRequire("ljm2R");

var $efvKr = parcelRequire("efvKr");

var $9vJRo = parcelRequire("9vJRo");

var $de2j9 = parcelRequire("de2j9");

var $kAra1 = parcelRequire("kAra1");
const $7b518c1026e9fbcc$var$i18n = (0, $2nPZH.defineMessages)({
    HomeLink: {
        id: "app-navigation.home.link",
        defaultMessage: "Home"
    }
});

const $7b518c1026e9fbcc$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("04nCC"))).fireHomeClickedAnalytics);
const $7b518c1026e9fbcc$export$40d01d2a751930be = /*#__PURE__*/ (0, $gwFzn.memo)(({ testId: testId, pendoId: pendoId })=>{
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { resetStickySearchRef: resetStickySearchRef } = (0, $gwFzn.useContext)((0, $lBYCH.AppNavigationContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $7b518c1026e9fbcc$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const handleClick = (0, $gwFzn.useCallback)(()=>{
        resetStickySearchRef?.current?.();
        fireClickAnalytics();
    }, [
        fireClickAnalytics,
        resetStickySearchRef
    ]);
    const isOnHomeOrWikiRouteArgs = {
        selector: (routeName)=>{
            if (!routeName) return false;
            return routeName === (0, $1NBp8.WIKI).name || routeName === (0, $1NBp8.HOME).name;
        }
    };
    const isHighlighted = (0, $dPJCf.useRouteName)(isOnHomeOrWikiRouteArgs);
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9vJRo.HomeOnboardingTakeoverV2HomeNudge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kAra1.PrimaryItem), {
        testId: testId,
        i18n: $7b518c1026e9fbcc$var$i18n.HomeLink,
        namedRoute: (0, $1NBp8.HOME),
        deprecatedKeyboardShortcut: !(isLiveEditMode || isOnEditRoute) ? (0, $ljm2R.GO_HOME_SHORTCUT) : undefined,
        keyboardShortcut: (0, $ljm2R.UNIVERSAL_GO_HOME_SHORTCUT),
        keyboardShortcutString: (0, $ljm2R.UNIVERSAL_GO_HOME_SHORTCUT),
        isAppNavigationShortcut: true,
        onClick: handleClick,
        isHighlighted: isHighlighted,
        pendoId: pendoId
    }));
});

});
parcelRegister("04nCC", function(module, exports) {

let $00d2b2a6b7c53120$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $00d2b2a6b7c53120$var$load("f6Avr").then(()=>parcelRequire('1ouZ7'));

});


parcelRegister("6CulZ", function(module, exports) {

$parcel$export(module.exports, "SpacesItem", () => $c906fa5c868b250b$export$e60b35895fc7fef7);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");

var $inPa6 = parcelRequire("inPa6");

var $5izcQ = parcelRequire("5izcQ");

var $irVI7 = parcelRequire("irVI7");

var $1NBp8 = parcelRequire("1NBp8");

var $5WLjq = parcelRequire("5WLjq");

var $d1q6u = parcelRequire("d1q6u");

var $dPJCf = parcelRequire("dPJCf");

var $bQm3c = parcelRequire("bQm3c");

var $ep3mz = parcelRequire("ep3mz");

var $epLE5 = parcelRequire("epLE5");

var $bqyIi = parcelRequire("bqyIi");

var $hqD0X = parcelRequire("hqD0X");

var $gIdnC = parcelRequire("gIdnC");

var $cEgMD = parcelRequire("cEgMD");

var $gz8ZY = parcelRequire("gz8ZY");

var $jzz8G = parcelRequire("jzz8G");
const $c906fa5c868b250b$var$i18n = (0, $2nPZH.defineMessages)({
    spacesButton: {
        id: "app-navigation.spaces.link",
        defaultMessage: "Spaces"
    }
});

const $c906fa5c868b250b$var$useLazyOnClick = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("04nCC"))).fireSpacesClickedAnalytics);
const $c906fa5c868b250b$var$useModeParameter = (0, $dPJCf.createSingleQueryParamHook)('mode');
const $c906fa5c868b250b$export$e60b35895fc7fef7 = /*#__PURE__*/ (0, $gwFzn.memo)(({ testId: testId, pendoId: pendoId })=>{
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const modeParameter = $c906fa5c868b250b$var$useModeParameter();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    // @ts-ignore FIXME: `spaceKey` can be `undefined` here, and needs proper handling
    const selectedSpaceKey = spaceKey;
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { isEnabled: isOnboardingNewHomeTakeoverEnabled } = (0, $gIdnC.useOnboardingNewHomeTakeoverEnabled)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onClick = $c906fa5c868b250b$var$useLazyOnClick(createAnalyticsEvent, routeDataRef);
    const onHover = (0, $gwFzn.useCallback)(()=>{
        (0, $d1q6u.SpacesDropdown).preload();
        (0, $5WLjq.preloadSpacesList)({
            isLicensed: isLicensed,
            selectedSpaceKey: selectedSpaceKey
        });
    }, [
        isLicensed,
        selectedSpaceKey
    ]);
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const content = ({ closePopup: closePopup })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d1q6u.SpacesDropdown), {
            closePopup: closePopup,
            isNav4Enabled: isNav4Enabled
        });
    const isOnSpaceRouteArgs = {
        selector: (routeName)=>{
            if (!routeName) return false;
            return routeName === (0, $1NBp8.SPACE_DIRECTORY).name;
        }
    };
    const isOnSpaceRoute = (0, $dPJCf.useRouteName)(isOnSpaceRouteArgs);
    const isHighlighted = !(0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) && isOnSpaceRoute && !modeParameter?.includes('global');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bqyIi.TopNavItemNudgeWrappable), {
        target: (0, $hqD0X.HOVER_TARGET).SPACES,
        shouldWrap: isOnboardingNewHomeTakeoverEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
        name: "app-navigation-spaces-dropdown"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jzz8G.PrimaryDropdownItem), {
        triggerId: "app-navigation-spaces-dropdown-trigger",
        testId: testId,
        i18n: $c906fa5c868b250b$var$i18n.spacesButton,
        content: content,
        collapsedTestId: "app-navigation-collapsed-spaces",
        onOpen: ()=>onClick(true),
        onClose: ()=>onClick(false),
        onHover: onHover,
        isHighlighted: isHighlighted,
        experienceName: (0, $irVI7.APP_NAV_SPACES_DROPDOWN_EXPERIENCE),
        pendoId: pendoId
    }))));
});

});
parcelRegister("jzz8G", function(module, exports) {

$parcel$export(module.exports, "closeCurrentPopup", () => $8bfd4e1b87550285$export$96e03b37dcd78d12);
$parcel$export(module.exports, "setCloseCurrentPopup", () => $8bfd4e1b87550285$export$5fc7d0ba124088f4);
$parcel$export(module.exports, "PrimaryDropdownItem", () => $8bfd4e1b87550285$export$e481c75e5604027b);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $lnHWt = parcelRequire("lnHWt");

var $6R5uz = parcelRequire("6R5uz");

var $56M4r = parcelRequire("56M4r");

var $3gadb = parcelRequire("3gadb");

var $lGgRw = parcelRequire("lGgRw");

var $dhlon = parcelRequire("dhlon");
var $aJmpt = parcelRequire("aJmpt");

var $9wGTI = parcelRequire("9wGTI");

var $dPJCf = parcelRequire("dPJCf");

var $aJPUt = parcelRequire("aJPUt");
var $1kHsc = parcelRequire("1kHsc");

var $ljm2R = parcelRequire("ljm2R");

var $lBYCH = parcelRequire("lBYCH");

var $eainP = parcelRequire("eainP");
const $8bfd4e1b87550285$var$noop = ()=>{};
let $8bfd4e1b87550285$export$96e03b37dcd78d12 = $8bfd4e1b87550285$var$noop;
const $8bfd4e1b87550285$export$5fc7d0ba124088f4 = (closeCallback)=>{
    $8bfd4e1b87550285$export$96e03b37dcd78d12 = closeCallback || $8bfd4e1b87550285$var$noop;
};
const $8bfd4e1b87550285$var$stopPopupPropagation = (event)=>event.stopPropagation();
function $8bfd4e1b87550285$var$getContentComponent(props) {
    return 'ContentComponent' in props ? props.ContentComponent : props.content;
}
// PrimaryPopup is rendered in the top navigation (not in the "More" menu)
const $8bfd4e1b87550285$var$PrimaryPopup = ({ triggerId: triggerId, content: content, i18n: i18n, testId: testId, isOpen: isOpen, isHighlighted: isHighlighted, closePopup: closePopup, onTriggerClick: onTriggerClick, onHover: onHover, keyboardShortcutString: keyboardShortcutString, pendoId: pendoId })=>{
    const [areKeyboardShortcutsEnabled] = (0, $ljm2R.useKeyboardShortcutsState)();
    const { primaryDropdownItemRef: primaryDropdownItemRef } = (0, $gwFzn.useContext)((0, $lBYCH.AppNavigationContext));
    const Trigger = (triggerProps)=>{
        const button = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
            "data-testid": `${testId}-dropdown`,
            "data-pendo-id": pendoId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), i18n));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dhlon.PrimaryDropdownButton), {
            ...triggerProps,
            id: triggerId,
            onClick: onTriggerClick,
            onMouseEnter: onHover,
            isHighlighted: isHighlighted,
            isSelected: isOpen,
            ref: primaryDropdownItemRef ? (0, $lnHWt.mergeRefs)([
                triggerProps.ref,
                primaryDropdownItemRef
            ]) : triggerProps.ref
        }, !!keyboardShortcutString ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
            content: areKeyboardShortcutsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutVisualizer), {
                shortcut: keyboardShortcutString,
                isTooltip: true
            }),
            tag: "span",
            hideTooltipOnClick: true
        }, button) : button);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: closePopup,
        trigger: Trigger,
        placement: "bottom-start",
        content: content,
        shouldRenderToParent: true
    });
};
// CollapsedPopup is rendered in the "More" menu of top navigation
class $8bfd4e1b87550285$var$CollapsedPopup extends (0, $gwFzn.Component) {
    componentWillUnmount() {
        this.props.closePopup('more menu closed');
    }
    renderContent(contentProps) {
        return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            onClick: $8bfd4e1b87550285$var$stopPopupPropagation
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(this.props.content, contentProps)));
    }
    renderTrigger(triggerProps) {
        const { i18n: i18n, testId: testId, isOpen: isOpen, onTriggerClick: onTriggerClick, onHover: onHover, pendoId: pendoId } = this.props;
        return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            ...triggerProps,
            onMouseEnter: onHover
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eainP.PrimaryItemWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $56M4r.default), {
            "data-pendo-id": pendoId,
            "data-testid": testId,
            onClick: onTriggerClick,
            isSelected: isOpen,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                label: "dropdown-chevron",
                size: "small"
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), i18n)))));
    }
    render() {
        const { isOpen: isOpen, closePopup: closePopup } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
            offset: [
                12,
                -11
            ],
            isOpen: isOpen,
            onClose: closePopup,
            content: this.renderContent,
            trigger: this.renderTrigger,
            placement: "right-start",
            shouldRenderToParent: (0, $9wGTI.fg)('should-render-to-parent-should-be-truedisco')
        });
    }
    constructor(props){
        super(props);
        this.renderContent = this.renderContent.bind(this);
        this.renderTrigger = this.renderTrigger.bind(this);
    }
}
const $8bfd4e1b87550285$export$e481c75e5604027b = /*#__PURE__*/ (0, $gwFzn.memo)(({ triggerId: triggerId, testId: primaryTestId, collapsedTestId: collapsedTestId, i18n: i18n, onOpen: onOpen, onClose: onClose, onClick: onClick, onHover: onHover, experienceName: experienceName, keyboardShortcut: keyboardShortcut, deprecatedKeyboardShortcut: deprecatedKeyboardShortcut, onShortcutPressed: onShortcutPressed, isHighlighted: isHighlighted, forceOpen: forceOpen, isAppNavigationShortcut: isAppNavigationShortcut, pendoId: pendoId, keyboardShortcutString: keyboardShortcutString, ...contentComponentProps })=>{
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(forceOpen);
    const { isVisible: isVisible } = (0, $aJmpt.useOverflowStatus)();
    const transitionId = (0, $dPJCf.useTransitionId)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const Content = $8bfd4e1b87550285$var$getContentComponent(contentComponentProps);
    let PopupComponent, testId;
    if (isVisible) {
        PopupComponent = $8bfd4e1b87550285$var$PrimaryPopup;
        testId = primaryTestId;
    } else {
        PopupComponent = $8bfd4e1b87550285$var$CollapsedPopup;
        testId = collapsedTestId;
    }
    const abortExperienceTracker = (0, $gwFzn.useCallback)((reason)=>{
        experienceTracker.abort({
            name: experienceName,
            reason: `Primary dropdown menu: ${typeof reason === 'string' ? reason : 'closed by user'}`,
            attributes: {
                navVersion: '3'
            }
        });
    }, [
        experienceName,
        experienceTracker
    ]);
    const closePopup = (0, $gwFzn.useCallback)((reason)=>{
        if (isOpen) {
            abortExperienceTracker(reason);
            $8bfd4e1b87550285$export$5fc7d0ba124088f4(undefined);
            setIsOpen(false);
            onClose && onClose();
        }
    }, [
        isOpen,
        onClose,
        abortExperienceTracker
    ]);
    const openPopup = (0, $gwFzn.useCallback)(()=>{
        if (!isOpen) {
            experienceTracker.start({
                name: experienceName,
                timeout: (0, $aJPUt.ExperienceTimeout).NAVIGATION_LOAD,
                attributes: {
                    navVersion: '3'
                }
            });
            $8bfd4e1b87550285$export$96e03b37dcd78d12(`${testId} menu opened`);
            setIsOpen(true);
            onOpen && onOpen();
        }
    }, [
        isOpen,
        experienceName,
        onOpen,
        testId,
        experienceTracker
    ]);
    const onTriggerClick = (0, $gwFzn.useCallback)((e)=>{
        if (isOpen) closePopup('trigger clicked');
        else openPopup();
        onClick && onClick(e);
    }, [
        openPopup,
        closePopup,
        isOpen,
        onClick
    ]);
    const shortcutListener = ()=>{
        onShortcutPressed && onShortcutPressed(!isVisible);
        if (isVisible) openPopup();
    };
    (0, $gwFzn.useEffect)(()=>{
        if (isOpen) $8bfd4e1b87550285$export$5fc7d0ba124088f4(closePopup);
    }, [
        isOpen,
        closePopup
    ]);
    const transitionIdRef = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useEffect)(()=>{
        if (transitionIdRef.current !== null && transitionIdRef.current !== transitionId) closePopup('route changed');
        transitionIdRef.current = transitionId;
    }, [
        transitionId,
        closePopup
    ]);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            abortExperienceTracker('route changed');
        };
    }, [
        abortExperienceTracker
    ]);
    const content = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Content, {
            closePopup: closePopup
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PopupComponent, {
        triggerId: triggerId,
        content: content,
        testId: testId,
        i18n: i18n,
        isOpen: isOpen,
        isHighlighted: isHighlighted,
        closePopup: closePopup,
        onTriggerClick: onTriggerClick,
        onHover: onHover,
        pendoId: pendoId
    }), keyboardShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
        deprecatedAccelerator: deprecatedKeyboardShortcut,
        accelerator: keyboardShortcut,
        listener: shortcutListener,
        isAppNavigationShortcut: isAppNavigationShortcut || false
    }));
});

});


parcelRegister("f5yOH", function(module, exports) {

$parcel$export(module.exports, "PagesItem", () => $9c49ddbf95e1c1ea$export$5c76b0ebb1236a53);
/* PagesItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $inPa6 = parcelRequire("inPa6");

var $irVI7 = parcelRequire("irVI7");
var $1kHsc = parcelRequire("1kHsc");

var $9Yv8Z = parcelRequire("9Yv8Z");
parcelRequire("23h2o");
var $14KJf = parcelRequire("14KJf");
var $23h2o = parcelRequire("23h2o");

var $dPJCf = parcelRequire("dPJCf");

var $bQm3c = parcelRequire("bQm3c");

var $5cryL = parcelRequire("5cryL");

var $bqyIi = parcelRequire("bqyIi");

var $hqD0X = parcelRequire("hqD0X");

var $gIdnC = parcelRequire("gIdnC");

var $ivb8S = parcelRequire("ivb8S");

var $epLE5 = parcelRequire("epLE5");

var $ljm2R = parcelRequire("ljm2R");

var $kDja4 = parcelRequire("kDja4");

var $yuLaV = parcelRequire("yuLaV");

var $9wGTI = parcelRequire("9wGTI");

var $efvKr = parcelRequire("efvKr");

var $de2j9 = parcelRequire("de2j9");

var $jhwJP = parcelRequire("jhwJP");

var $gTyTP = parcelRequire("gTyTP");

var $jzz8G = parcelRequire("jzz8G");
const $9c49ddbf95e1c1ea$var$i18nBase = (0, $2nPZH.defineMessages)({
    pagesButton: {
        id: "app-navigation.recent.link",
        defaultMessage: "Recent"
    },
    yourWorkButton: {
        id: "app-navigation.your-work.link",
        defaultMessage: "Your work"
    },
    nudgeTooltip: {
        id: "app-navigation.editor-onboarding.nudge.tooltip",
        defaultMessage: "Need to get back to a draft? Find it in the <b>Recent</b> tab."
    },
    nudgeTooltipLivePages: {
        id: "app-navigation.editor-onboarding.nudge.tooltip.live-pages",
        defaultMessage: "Need to get back to a page? Find it in the <b>Recent</b> tab."
    }
});
const $9c49ddbf95e1c1ea$var$i18nLiveDocs = (0, $2nPZH.defineMessages)({
    nudgeTooltipLivePages: {
        id: "app-navigation.editor-onboarding.nudge.tooltip.live-pages.livedocs",
        defaultMessage: "Need to get back to a page or live doc? Find it in the <b>Recent</b> tab."
    }
});
const $9c49ddbf95e1c1ea$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($9c49ddbf95e1c1ea$var$i18nBase, $9c49ddbf95e1c1ea$var$i18nLiveDocs); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9c49ddbf95e1c1ea$var$NudgeFixer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o",
            __cmplp.className
        ])
    });
});

const $9c49ddbf95e1c1ea$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("04nCC"))).fireRecentsClickedAnalytics);
const $9c49ddbf95e1c1ea$var$PrimaryDropdownContent = ({ closePopup: closePopup })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $23h2o.RecentPagesLazy), {
        closePopup: closePopup
    });
};
const $9c49ddbf95e1c1ea$export$5c76b0ebb1236a53 = /*#__PURE__*/ (0, $gwFzn.memo)(({ testId: testId })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const [isNudgeHidden, setIsNudgeHidden] = (0, $gwFzn.useState)(true);
    const [forceOpen, setForceOpen] = (0, $gwFzn.useState)(false);
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isEnabled: isOnboardingNewHomeTakeoverEnabled } = (0, $gIdnC.useOnboardingNewHomeTakeoverEnabled)();
    const { data: data, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS)), !(0, $9wGTI.fg)('cc_onboarding_experience'));
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isWhiteboardViewedEnabled = isWhiteboardFeatureEnabled('whiteboardsEnabled');
    const isWhiteboardUpdatedEnabled = isWhiteboardFeatureEnabled('whiteboardsEnabled');
    const isDatabaseEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    // Start Experience Tracker
    (0, $gwFzn.useEffect)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.ONBOARDING_EDITOR_RECENT_DRAFT_SPOTLIGHT_EXPERIENCE)
        });
    }, [
        experienceTracker
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (data && !loading && !error) {
            const editorOnboardingEligiblity = data?.onboardingState?.find((prop)=>prop.key === (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).EDITOR_ONBOARDING_ELIGIBLE_NEW)?.value === 'true';
            const recentSpotlightOpen = data?.onboardingState?.find((prop)=>prop.key === (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).RECENT_SPOTLIGHT_OPEN)?.value === 'true'; // If the spotlight hasn't been seen before
            if (editorOnboardingEligiblity && recentSpotlightOpen) {
                setIsNudgeHidden(false); // Change onboarding state to only show the banner once
                setOnboardingState({
                    key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).RECENT_SPOTLIGHT_SEEN,
                    value: 'true'
                });
                setOnboardingState({
                    key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).RECENT_SPOTLIGHT_OPEN,
                    value: 'false'
                }); // End Experience Tracker
                experienceTracker.succeed({
                    name: (0, $irVI7.ONBOARDING_EDITOR_RECENT_DRAFT_SPOTLIGHT_EXPERIENCE)
                });
            }
        } else if (error && !loading) // Fail Experience Tracker
        experienceTracker.fail({
            name: (0, $irVI7.ONBOARDING_EDITOR_RECENT_DRAFT_SPOTLIGHT_EXPERIENCE),
            error: error
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data,
        loading,
        error
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onClick = $9c49ddbf95e1c1ea$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const onOpen = (0, $gwFzn.useCallback)(()=>{
        setIsNudgeHidden(true);
        setForceOpen(true);
        onClick(true);
    }, [
        onClick
    ]);
    const onHover = (0, $gwFzn.useCallback)(()=>{
        (0, $23h2o.RecentPagesLazy).preload();
        (0, $14KJf.preloadRecentPages)({
            cloudId: cloudId,
            isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
            isWhiteboardUpdatedEnabled: isWhiteboardUpdatedEnabled,
            isDatabaseEnabled: isDatabaseEnabled
        });
    }, [
        cloudId,
        isWhiteboardViewedEnabled,
        isWhiteboardUpdatedEnabled,
        isDatabaseEnabled
    ]);
    const tooltipMessage = isLivePagesFeatureEnabled ? $9c49ddbf95e1c1ea$var$i18n.nudgeTooltipLivePages : $9c49ddbf95e1c1ea$var$i18n.nudgeTooltip;
    const labelMessage = $9c49ddbf95e1c1ea$var$i18n.pagesButton;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9Yv8Z.OnboardingCTANudge), {
        hidden: isNudgeHidden,
        position: "bottom-start",
        wrapper: $9c49ddbf95e1c1ea$var$NudgeFixer,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            ...tooltipMessage,
            values: {
                b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("b", null, chunks)
            }
        }),
        source: "onboardingNudge",
        actionSubjectId: "recentItem",
        width: 280,
        renderChildrenWhileLoading: true,
        dataVC: "app-navigation-primary-pages-dropdown"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bqyIi.TopNavItemNudgeWrappable), {
        target: (0, $hqD0X.HOVER_TARGET).RECENT_PAGES,
        shouldWrap: isOnboardingNewHomeTakeoverEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jzz8G.PrimaryDropdownItem), {
        testId: testId,
        i18n: labelMessage,
        ContentComponent: $9c49ddbf95e1c1ea$var$PrimaryDropdownContent,
        collapsedTestId: "app-navigation-collapsed-pages",
        onOpen: onOpen,
        onClose: ()=>onClick(false),
        onHover: onHover,
        deprecatedKeyboardShortcut: !(isLiveEditMode || isOnEditRoute) ? (0, $ljm2R.GO_TO_RECENT_SHORTCUT) : undefined,
        keyboardShortcut: (0, $ljm2R.UNIVERSAL_GO_TO_RECENT_SHORTCUT),
        keyboardShortcutString: (0, $ljm2R.UNIVERSAL_GO_TO_RECENT_SHORTCUT),
        experienceName: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
        forceOpen: forceOpen
    })));
});

});
parcelRegister("23h2o", function(module, exports) {

$parcel$export(module.exports, "RecentPagesLazy", () => $af567a795d687171$export$d9a3996f4e8cc515);
$parcel$export(module.exports, "preloadRecentPages", () => (parcelRequire("14KJf")).preloadRecentPages);

var $jmjWc = parcelRequire("jmjWc");

var $14KJf = parcelRequire("14KJf");

const $af567a795d687171$export$d9a3996f4e8cc515 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Ab594",
    name: "RecentPagesLazy",
    loader: async ()=>(await (parcelRequire("e7QK2"))).RecentPages
});

});
parcelRegister("14KJf", function(module, exports) {

$parcel$export(module.exports, "preloadRecentPages", () => $0e3a4a71b4c974fa$export$1b98455ce5fec513);

var $2lAwa = parcelRequire("2lAwa");

var $dYU3e = parcelRequire("dYU3e");

var $6mKj3 = parcelRequire("6mKj3");

var $aF6h6 = parcelRequire("aF6h6");

var $heDAM = parcelRequire("heDAM");

var $2e2Xr = parcelRequire("2e2Xr");
function $0e3a4a71b4c974fa$export$1b98455ce5fec513({ cloudId: cloudId, recentTab: recentTab = 0, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled = false, isWhiteboardUpdatedEnabled: isWhiteboardUpdatedEnabled = false, isDatabaseEnabled: isDatabaseEnabled = false }) {
    const queries = $0e3a4a71b4c974fa$var$getRecentPagesQueries(cloudId, isWhiteboardViewedEnabled, isWhiteboardUpdatedEnabled, isDatabaseEnabled, (0, $6mKj3.expVal)('confluence_activity_v3_collaborated_on_experiment', 'isEnabled', false));
    const queryParams = recentTab < 0 || recentTab >= queries.length ? queries[0] : queries[recentTab];
    return (0, $dYU3e.query)(queryParams);
}
const $0e3a4a71b4c974fa$var$getRecentPagesQueries = (cloudId, isWhiteboardViewedEnabled, isWhiteboardUpdatedEnabled, isDatabaseEnabled, isActivityV3MigrationEnabled)=>[
        {
            query: isActivityV3MigrationEnabled ? (0, $heDAM.RecentActivityQuery) : (0, $heDAM.RecentlyViewedQuery),
            variables: {
                cloudId: isActivityV3MigrationEnabled ? (0, $2lAwa.PlatformSiteAri).create({
                    siteId: cloudId
                }).toString() : cloudId,
                first: (0, $aF6h6.PAGE_SIZE),
                after: '',
                eventTypes: [],
                objectTypes: [
                    ...(0, $aF6h6.OBJECT_TYPES),
                    ...isWhiteboardViewedEnabled ? [
                        (0, $2e2Xr.ActivitiesObjectType).WHITEBOARD
                    ] : [],
                    ...isDatabaseEnabled ? [
                        (0, $2e2Xr.ActivitiesObjectType).DATABASE
                    ] : []
                ]
            }
        },
        {
            query: isActivityV3MigrationEnabled ? (0, $heDAM.RecentActivityQuery) : (0, $heDAM.RecentlyWorkedOnQuery),
            variables: {
                cloudId: isActivityV3MigrationEnabled ? (0, $2lAwa.PlatformSiteAri).create({
                    siteId: cloudId
                }).toString() : cloudId,
                first: (0, $aF6h6.PAGE_SIZE),
                after: '',
                eventTypes: (0, $aF6h6.WORKED_ON_EVENT_TYPES),
                objectTypes: [
                    ...(0, $aF6h6.OBJECT_TYPES),
                    ...isWhiteboardUpdatedEnabled ? [
                        (0, $2e2Xr.ActivitiesObjectType).WHITEBOARD
                    ] : [],
                    ...isDatabaseEnabled ? [
                        (0, $2e2Xr.ActivitiesObjectType).DATABASE
                    ] : []
                ]
            }
        },
        {
            query: (0, $heDAM.RecentlyCreatedByMeQuery),
            variables: {
                cql: 'type in (page, blogpost, embed) and creator=currentUser() order by created desc',
                cqlcontext: `{"contentStatuses":["draft", "current"]}`,
                first: (0, $aF6h6.PAGE_SIZE),
                after: ''
            }
        },
        {
            query: (0, $heDAM.RecentlyStarredQuery),
            variables: {
                limit: (0, $aF6h6.PAGE_SIZE),
                start: 0
            }
        },
        {
            query: (0, $heDAM.RecentlyDraftedQuery),
            variables: {
                first: (0, $aF6h6.PAGE_SIZE),
                context: `{"contentStatuses":["draft"]}`
            }
        }
    ];

});
parcelRegister("aF6h6", function(module, exports) {

$parcel$export(module.exports, "PAGE_SIZE", () => $b9347f6d6f606b03$export$8ec3d08588d2eeda);
$parcel$export(module.exports, "WORKED_ON_EVENT_TYPES", () => $b9347f6d6f606b03$export$507c2df9171a0432);
$parcel$export(module.exports, "WORKED_ON_EVENT_TYPES_V3", () => $b9347f6d6f606b03$export$58c27a79abd84d0);
$parcel$export(module.exports, "OBJECT_TYPES", () => $b9347f6d6f606b03$export$c49cfb2681596b20);

var $2e2Xr = parcelRequire("2e2Xr");
const $b9347f6d6f606b03$export$8ec3d08588d2eeda = 25;
var $b9347f6d6f606b03$var$ActivityEventType = /*#__PURE__*/ function(ActivityEventType) {
    ActivityEventType["ASSIGNED"] = "ASSIGNED";
    ActivityEventType["COMMENTED"] = "COMMENTED";
    ActivityEventType["CREATED"] = "CREATED";
    ActivityEventType["EDITED"] = "EDITED";
    ActivityEventType["LIKED"] = "LIKED";
    ActivityEventType["PUBLISHED"] = "PUBLISHED";
    ActivityEventType["SNAPSHOTTED"] = "SNAPSHOTTED";
    ActivityEventType["STARTED"] = "STARTED";
    ActivityEventType["TRANSITIONED"] = "TRANSITIONED";
    ActivityEventType["UNASSIGNED"] = "UNASSIGNED";
    ActivityEventType["UPDATED"] = "UPDATED";
    ActivityEventType["VIEWED"] = "VIEWED";
    return ActivityEventType;
}($b9347f6d6f606b03$var$ActivityEventType || {});
const $b9347f6d6f606b03$export$507c2df9171a0432 = [
    "COMMENTED",
    "EDITED",
    "PUBLISHED",
    "UPDATED"
];
const $b9347f6d6f606b03$export$58c27a79abd84d0 = [
    "EDITED",
    "PUBLISHED",
    "UPDATED",
    "CREATED",
    "STARTED",
    "SNAPSHOTTED"
];
const $b9347f6d6f606b03$export$c49cfb2681596b20 = [
    (0, $2e2Xr.ActivitiesObjectType).PAGE,
    (0, $2e2Xr.ActivitiesObjectType).BLOGPOST,
    (0, $2e2Xr.ActivitiesObjectType).EMBED
];

});
parcelRegister("2e2Xr", function(module, exports) {

$parcel$export(module.exports, "ActivitiesObjectType", () => $d78b00364c50a4b1$export$4edf00fad4b97379);
/**
 * @generated SignedSource<<092d564f50562bdfde371e4db0475185>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $d78b00364c50a4b1$export$4edf00fad4b97379 = /*#__PURE__*/ function(ActivitiesObjectType) {
    ActivitiesObjectType["ISSUE"] = "ISSUE";
    ActivitiesObjectType["PAGE"] = "PAGE";
    ActivitiesObjectType["BLOGPOST"] = "BLOGPOST";
    ActivitiesObjectType["WHITEBOARD"] = "WHITEBOARD";
    ActivitiesObjectType["DATABASE"] = "DATABASE";
    ActivitiesObjectType["EMBED"] = "EMBED";
    return ActivitiesObjectType;
}({});
var $d78b00364c50a4b1$export$132f858337fea016 = /*#__PURE__*/ function(ActivityEventType) {
    ActivityEventType["ASSIGNED"] = "ASSIGNED";
    ActivityEventType["UNASSIGNED"] = "UNASSIGNED";
    ActivityEventType["VIEWED"] = "VIEWED";
    ActivityEventType["COMMENTED"] = "COMMENTED";
    ActivityEventType["UPDATED"] = "UPDATED";
    ActivityEventType["CREATED"] = "CREATED";
    ActivityEventType["LIKED"] = "LIKED";
    ActivityEventType["TRANSITIONED"] = "TRANSITIONED";
    ActivityEventType["PUBLISHED"] = "PUBLISHED";
    ActivityEventType["EDITED"] = "EDITED";
    return ActivityEventType;
}({});

});


parcelRegister("heDAM", function(module, exports) {

$parcel$export(module.exports, "RecentlyViewedQuery", () => $37a242e79a4da2a6$export$4e20ef3fda88f1f1);
$parcel$export(module.exports, "RecentlyWorkedOnQuery", () => $37a242e79a4da2a6$export$23e61bcffa5b3801);
$parcel$export(module.exports, "RecentActivityQuery", () => $37a242e79a4da2a6$export$2b031b10d620201);
$parcel$export(module.exports, "RecentlyCreatedByMeQuery", () => $37a242e79a4da2a6$export$edfbeed0a6e5a970);
$parcel$export(module.exports, "RecentlyDraftedQuery", () => $37a242e79a4da2a6$export$67db684d1b58d14f);
$parcel$export(module.exports, "RecentlyStarredQuery", () => $37a242e79a4da2a6$export$1ed519d0d57bef3a);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $37a242e79a4da2a6$export$4e20ef3fda88f1f1 = (0, $d2LG0.default)`query RecentlyViewedQuery($cloudId:ID!$first:Int$after:String$eventTypes:[ActivityEventType!]$objectTypes:[ActivitiesObjectType!]){activities{myActivities{all(filters:[{type:AND arguments:{products:[CONFLUENCE]objectTypes:$objectTypes cloudIds:[$cloudId]eventTypes:$eventTypes}}]first:$first after:$after){edges{cursor node{id timestamp object{id events{eventType}content{id type subType title status blank metadata{currentuser{favourited{isFavourite favouritedDate}lastcontributed{status when}scheduled{isScheduled}}}links{webui editui}editorVersion:properties(key:"editor"){nodes{id key value}}space{id key name}emoji:properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id key value}}}}}}pageInfo{hasNextPage}}}}}`;
const $37a242e79a4da2a6$export$23e61bcffa5b3801 = (0, $d2LG0.default)`query RecentlyWorkedOnQuery($cloudId:ID!$first:Int$after:String$eventTypes:[ActivityEventType!]$objectTypes:[ActivitiesObjectType!]){activities{myActivities{all(filters:[{type:AND arguments:{products:[CONFLUENCE]objectTypes:$objectTypes cloudIds:[$cloudId]eventTypes:$eventTypes}}]first:$first after:$after){edges{cursor node{id timestamp object{id events{eventType}content{id type subType title status blank metadata{currentuser{favourited{isFavourite favouritedDate}lastcontributed{status when}scheduled{isScheduled}}}links{webui editui}editorVersion:properties(key:"editor"){nodes{id key value}}space{id key name}emoji:properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id key value}}}}}}pageInfo{hasNextPage}}}}}`;
const $37a242e79a4da2a6$export$2b031b10d620201 = (0, $d2LG0.default)`query RecentActivityQuery($cloudId:ID!$first:Int$after:String$eventTypes:[String!]$objectTypes:[String!]){activity{myActivity{all(filter:{type:AND rootContainerIds:[$cloudId]arguments:{products:["CONFLUENCE"]objectTypes:$objectTypes eventTypes:$eventTypes}}first:$first after:$after){edges{cursor node{id object{id data{...on ConfluencePage{id title type subtype pageStatus:status createdAt links{webUi editUi}viewer{favoritedSummary{isFavorite}lastContribution{status}scheduledPublishSummary{isScheduled}}space{id alias key name}editorVersion:properties(keys:["editor"]){value}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceBlogPost{id title type blogStatus:status createdAt links{webUi editUi}viewer{favoritedSummary{isFavorite}lastContribution{status}scheduledPublishSummary{isScheduled}}space{id alias key name}editorVersion:properties(keys:["editor"]){value}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceWhiteboard{id title type status links{webUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}}...on ConfluenceDatabase{id title type status links{webUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}}...on ConfluenceEmbed{id title type status links{webUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}}}event{timestamp eventType}}}}}}}`;
const $37a242e79a4da2a6$export$edfbeed0a6e5a970 = (0, $d2LG0.default)`query RecentlyCreatedByMeQuery($cql:String!$cqlcontext:String!$first:Int$after:String){search:confluence_search(cql:$cql cqlcontext:$cqlcontext first:$first after:$after){nodes{url content{id type subType title status blank metadata{currentuser{favourited{isFavourite favouritedDate}lastcontributed{status when}scheduled{isScheduled}}}links{webui editui}editorVersion:properties(key:"editor"){nodes{id key value}}space{id key name}emoji:properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id key value}}space{alias}}}pageInfo{hasNextPage endCursor}}}`;
const $37a242e79a4da2a6$export$67db684d1b58d14f = (0, $d2LG0.default)`query RecentlyDraftedQuery($first:Int$after:String$context:String){search:confluence_search(cql:"type in (page,blogpost) order by lastModified desc" cqlcontext:$context first:$first after:$after){nodes{entityType url content{id type subType title status blank metadata{currentuser{favourited{isFavourite favouritedDate}lastcontributed{status when}scheduled{isScheduled}}}links{webui editui}editorVersion:properties(key:"editor"){nodes{id key value}}space{id key name}emoji:properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id key value}}space{alias}}}pageInfo{hasNextPage endCursor}}}`;
const $37a242e79a4da2a6$export$1ed519d0d57bef3a = (0, $d2LG0.default)`query RecentlyStarredQuery($limit:Int$start:Int){favoriteContent(limit:$limit start:$start){nodes{id type subType title status blank metadata{currentuser{favourited{isFavourite favouritedDate}lastcontributed{status when}scheduled{isScheduled}}}links{webui editui}editorVersion:properties(key:"editor"){nodes{id key value}}space{id key name}emoji:properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id key value}}}pageInfo{hasNextPage}}}`;

});


parcelRegister("e7QK2", function(module, exports) {

let $a48aa185ad27b72c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a48aa185ad27b72c$var$load("in0CI"),
    $a48aa185ad27b72c$var$load("InrG6"),
    $a48aa185ad27b72c$var$load("ex7Yl"),
    $a48aa185ad27b72c$var$load("6vzdH"),
    $a48aa185ad27b72c$var$load("hmhwB"),
    $a48aa185ad27b72c$var$load("eXlRV"),
    $a48aa185ad27b72c$var$load("7gjV3"),
    $a48aa185ad27b72c$var$load("gLxW3"),
    $a48aa185ad27b72c$var$load("6qah4"),
    $a48aa185ad27b72c$var$load("6nLV7"),
    $a48aa185ad27b72c$var$load("fqrMn"),
    $a48aa185ad27b72c$var$load("eVYW1"),
    $a48aa185ad27b72c$var$load("fYi1a"),
    $a48aa185ad27b72c$var$load("ls0Um"),
    $a48aa185ad27b72c$var$load("bjzRn"),
    $a48aa185ad27b72c$var$load("020xd"),
    $a48aa185ad27b72c$var$load("8mzoy"),
    $a48aa185ad27b72c$var$load("eTBsW"),
    $a48aa185ad27b72c$var$load("42vdC"),
    $a48aa185ad27b72c$var$load("1oiJ6"),
    $a48aa185ad27b72c$var$load("dil5i"),
    $a48aa185ad27b72c$var$load("2fk6g"),
    $a48aa185ad27b72c$var$load("hPalR"),
    $a48aa185ad27b72c$var$load("8059b"),
    $a48aa185ad27b72c$var$load("kIjBt"),
    $a48aa185ad27b72c$var$load("3wmvj"),
    $a48aa185ad27b72c$var$load("fe4be"),
    $a48aa185ad27b72c$var$load("jDjSj"),
    $a48aa185ad27b72c$var$load("kjZZD"),
    $a48aa185ad27b72c$var$load("c6MKV"),
    $a48aa185ad27b72c$var$load("aZinD"),
    $a48aa185ad27b72c$var$load("ffEVr"),
    $a48aa185ad27b72c$var$load("joJy8"),
    $a48aa185ad27b72c$var$load("aHE9G"),
    $a48aa185ad27b72c$var$load("hesl9")
]).then(()=>parcelRequire('7PGfP'));

});



parcelRegister("k4ueP", function(module, exports) {

$parcel$export(module.exports, "PeopleItem", () => $1a992850b4674fb6$export$fc6f2e50c81cabe1);
/* PeopleItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $js7oX = parcelRequire("js7oX");

var $ipPpS = parcelRequire("ipPpS");

var $diswb = parcelRequire("diswb");

var $inPa6 = parcelRequire("inPa6");

var $dhlon = parcelRequire("dhlon");

var $eoZW1 = parcelRequire("eoZW1");

var $g6zY9 = parcelRequire("g6zY9");

var $2iK1S = parcelRequire("2iK1S");

var $3jKGE = parcelRequire("3jKGE");

var $bQm3c = parcelRequire("bQm3c");

var $gqqjz = parcelRequire("gqqjz");

var $jmjWc = parcelRequire("jmjWc");

var $1NBp8 = parcelRequire("1NBp8");

var $dPJCf = parcelRequire("dPJCf");

var $dBcar = parcelRequire("dBcar");

var $9Yv8Z = parcelRequire("9Yv8Z");

var $lBYCH = parcelRequire("lBYCH");

var $epLE5 = parcelRequire("epLE5");

var $hSHWm = parcelRequire("hSHWm");
var $koZ31 = parcelRequire("koZ31");

var $bqyIi = parcelRequire("bqyIi");

var $hqD0X = parcelRequire("hqD0X");

var $gIdnC = parcelRequire("gIdnC");

var $dIouf = parcelRequire("dIouf");

var $7Sm4c = parcelRequire("7Sm4c");

var $eainP = parcelRequire("eainP");

var $djivE = parcelRequire("djivE");

var $jzz8G = parcelRequire("jzz8G");
const $1a992850b4674fb6$var$i18n = (0, $2nPZH.defineMessages)({
    InviteTeammatesV2: {
        id: "app-navigation.people.nudge.heading.v2",
        defaultMessage: "Add people here"
    },
    InviteTeammatesNudgeV2: {
        id: "app-navigation.people-nav-item-nudge-tooltip.v2",
        defaultMessage: "Invite teammates from the <b>People</b> menu, and you\u2019ll accomplish great things together in no time."
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1a992850b4674fb6$var$NudgeFixer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $1a992850b4674fb6$var$Placeholder = ({ remoteConfig: remoteConfig })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dhlon.PrimaryDropdownButton), null, remoteConfig.navLabel);
};
const $1a992850b4674fb6$var$LoadingState = (0, $2iK1S.withMandatoryPeopleMenuConfiguration)($1a992850b4674fb6$var$Placeholder);

const $1a992850b4674fb6$export$4a142491b2943a52 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VfjbC",
    name: "LazyPeopleMenu",
    loader: async ()=>(await (parcelRequire("aENWY"))).PeopleItemWrapper,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($1a992850b4674fb6$var$LoadingState, null),
    _noPreloadWhenRenderingSPA: true
});

const $1a992850b4674fb6$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("04nCC"))).firePeopleClickedAnalytics);
const $1a992850b4674fb6$var$peopleMenuFlagAppearanceToConfluenceFlagType = (appearance)=>{
    switch(appearance){
        case 'normal':
        case 'success':
            return 'success-circle';
        case 'warning':
            return 'warning';
        case 'error':
            return 'error';
        case 'info':
            return 'info';
        default:
            return 'custom';
    }
};
const $1a992850b4674fb6$var$addFlagFn = (flags)=>(flag)=>{
        const { title: title, description: description, appearance: appearance, actions: actions } = flag;
        flags.showFlag({
            type: $1a992850b4674fb6$var$peopleMenuFlagAppearanceToConfluenceFlagType(appearance),
            title: title,
            description: description,
            close: 'auto',
            actions: actions
        });
    };
const $1a992850b4674fb6$export$4519bf6c65da43ab = /*#__PURE__*/ (0, $gwFzn.memo)(({ testId: testId, intl: intl })=>{
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const transitionId = (0, $dPJCf.useTransitionId)();
    const { resetStickySearchRef: resetStickySearchRef } = (0, $gwFzn.useContext)((0, $lBYCH.AppNavigationContext));
    const { cloudId: cloudId, userId: userId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: error } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $djivE.AppNavigationUnifiedQuery));
    // this state is for People Menu
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const closePeopleMenu = (0, $gwFzn.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const openPeopleMenu = (0, $gwFzn.useCallback)(()=>setIsOpen(true), [
        setIsOpen
    ]);
    const { isEnabled: isOnboardingNewHomeTakeoverEnabled } = (0, $gIdnC.useOnboardingNewHomeTakeoverEnabled)();
    const resetStickySearch = (0, $gwFzn.useCallback)(()=>{
        resetStickySearchRef?.current?.();
    }, [
        resetStickySearchRef
    ]);
    const onItemClick = (0, $gwFzn.useCallback)((_id, _type)=>{
        resetStickySearchRef?.current?.();
    }, [
        resetStickySearchRef
    ]);
    const { openCoreInvites: openCoreInvites } = (0, $gwFzn.useContext)((0, $hSHWm.CoreInvitesContext));
    const invitePeopleHandlers = (0, $gwFzn.useMemo)(()=>{
        return openCoreInvites && {
            handleClick: ()=>openCoreInvites((0, $koZ31.CoreInvitesSource).PEOPLE_MENU)
        };
    }, [
        openCoreInvites
    ]);
    const { permissions: { canCreateTeams: canCreateTeams, canViewTeams: canViewTeams } } = (0, $3jKGE.useTeamsPermissionsService)({
        orgId: orgId,
        cloudId: cloudId
    }, {
        enabled: false // enableOpenSitesPermissionCheck
    });
    (0, $gwFzn.useEffect)(()=>{
        // Close people-menu when navigating to different URL
        return ()=>closePeopleMenu(); // do not add closePeopleMenu the dependency list.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        transitionId
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickedAnalytics = $1a992850b4674fb6$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const handleClickPeopleMenuDropdown = (0, $gwFzn.useCallback)(()=>{
        // sync open/close state with other menus
        if (!isOpen) {
            // now people-menu is going to open so we need to close other nav popups
            (0, $jzz8G.closeCurrentPopup)('people menu opened'); // so other menus open can close people-menu when they open.
            (0, $jzz8G.setCloseCurrentPopup)(closePeopleMenu);
        }
        fireClickedAnalytics();
    }, [
        isOpen,
        fireClickedAnalytics,
        closePeopleMenu
    ]);
    const isOnPeopleRouteArgs = {
        selector: (routeName)=>{
            if (!routeName) return false;
            return routeName === (0, $1NBp8.PEOPLE_DIRECTORY).name;
        }
    };
    const isHighlighted = (0, $dPJCf.useRouteName)(isOnPeopleRouteArgs);
    if ((0, $dIouf.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($1a992850b4674fb6$var$LoadingState, null);
    const user = {
        id: data?.user?.id,
        fullName: data?.user?.displayName,
        avatarUrl: data?.user?.photos?.[0]?.value
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9Yv8Z.OnboardingCTANudge), {
        position: "bottom-start",
        wrapper: $1a992850b4674fb6$var$NudgeFixer,
        heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $1a992850b4674fb6$var$i18n.InviteTeammatesV2),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            ...$1a992850b4674fb6$var$i18n.InviteTeammatesNudgeV2,
            values: {
                b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("b", null, chunks)
            }
        }),
        source: "onboardingNudge",
        actionSubjectId: (0, $dBcar.PEOPLE),
        renderChildrenWhileLoading: true,
        width: 280,
        dataVC: "app-navigation-teams-onboarding-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bqyIi.TopNavItemNudgeWrappable), {
            target: (0, $hqD0X.HOVER_TARGET).INVITE,
            shouldWrap: isOnboardingNewHomeTakeoverEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eainP.PrimaryItemWrapper), {
            "data-vc": "app-navigation-teams-onboarding-button-inner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $g6zY9.PeopleAndTeamsConfigurationProvider), {
            product: "confluence",
            locale: (0, $eoZW1.default)(intl.locale),
            teamPermissions: {
                canCreateTeams: canCreateTeams,
                canViewTeams: canViewTeams
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($1a992850b4674fb6$export$4a142491b2943a52, {
            cloudId: cloudId,
            userId: userId || '',
            product: "confluence",
            orgId: orgId,
            testId: testId,
            isHighlighted: isHighlighted,
            onClick: handleClickPeopleMenuDropdown,
            pushRoute: push,
            addFlag: $1a992850b4674fb6$var$addFlagFn(flags),
            isOpen: isOpen,
            onClose: closePeopleMenu,
            onOpen: openPeopleMenu,
            onClickViewPeopleDirectoryLink: resetStickySearch,
            onClickCreateNewTeam: resetStickySearch,
            onClickedItem: onItemClick,
            teamCreateDialogProps: {
                currentUser: {
                    ...user
                },
                enableMembershipSettingsChoice: true
            },
            invitePeopleHandlers: invitePeopleHandlers,
            shouldRenderToParent: true
        }))))));
});
const $1a992850b4674fb6$export$fc6f2e50c81cabe1 = (0, $js7oX.default)($1a992850b4674fb6$export$4519bf6c65da43ab);

});
parcelRegister("aENWY", function(module, exports) {

let $7c2462e2690e3eaf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $7c2462e2690e3eaf$var$load("in0CI"),
    $7c2462e2690e3eaf$var$load("hKqxh"),
    $7c2462e2690e3eaf$var$load("7sseo"),
    $7c2462e2690e3eaf$var$load("hCe0g"),
    $7c2462e2690e3eaf$var$load("5nE3O"),
    $7c2462e2690e3eaf$var$load("1ZAFx"),
    $7c2462e2690e3eaf$var$load("joJy8"),
    $7c2462e2690e3eaf$var$load("aHE9G"),
    $7c2462e2690e3eaf$var$load("ffEVr"),
    $7c2462e2690e3eaf$var$load("6JvQz")
]).then(()=>parcelRequire('4ikYV'));

});


parcelRegister("2idHG", function(module, exports) {

$parcel$export(module.exports, "AppsItem", () => $676e787a42c3de42$export$4c83861e794746b0);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");

var $inPa6 = parcelRequire("inPa6");

var $irVI7 = parcelRequire("irVI7");

var $dPJCf = parcelRequire("dPJCf");

var $eSLr0 = parcelRequire("eSLr0");
var $kxhju = parcelRequire("kxhju");

var $jmjWc = parcelRequire("jmjWc");

var $7Ndnw = parcelRequire("7Ndnw");
var $dizL5 = parcelRequire("dizL5");

var $epLE5 = parcelRequire("epLE5");

var $bQm3c = parcelRequire("bQm3c");

var $1BYn9 = parcelRequire("1BYn9");

var $jzz8G = parcelRequire("jzz8G");

var $d5p70 = parcelRequire("d5p70");
const $676e787a42c3de42$var$TOP_LEVEL_ITEMS = [
    (0, $d5p70.SPACE_DIRECTORY_KEY),
    (0, $d5p70.PEOPLE_DIRECTORY_KEY)
];
const $676e787a42c3de42$var$i18n = (0, $2nPZH.defineMessages)({
    appsButton: {
        id: "app-navigation.apps.link",
        defaultMessage: "Apps"
    }
});

const $676e787a42c3de42$var$AppsContentLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "JLrWz",
    name: "AppsContentLoader",
    loader: async ()=>(await (parcelRequire("lX5T4"))).AppsContent
});

const $676e787a42c3de42$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("04nCC"))).fireAppsClickedAnalytics);
const $676e787a42c3de42$export$4c83861e794746b0 = /*#__PURE__*/ (0, $gwFzn.memo)(({ testId: testId })=>{
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { isProductAdmin: isProductAdmin } = (0, $1BYn9.useIsProductAdmin)();
    const isPremiumEdition = edition === 'PREMIUM';
    const onClick = $676e787a42c3de42$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jzz8G.PrimaryDropdownItem), {
        testId: testId,
        collapsedTestId: "app-navigation-collapsed-apps",
        i18n: $676e787a42c3de42$var$i18n.appsButton,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kxhju.WebItemLocation), {
                key: "top-level-addons-location",
                location: (0, $eSLr0.SYSTEM_HEADER_LEFT),
                notAllowedWebItems: [
                    ...$676e787a42c3de42$var$TOP_LEVEL_ITEMS,
                    (!isPremiumEdition || !isProductAdmin) && (0, $d5p70.AUTOMATION_KEY)
                ],
                fetchPolicy: "cache-first",
                // @ts-expect-error FIXME: redundant prop, should be removed
                scope: "global"
            }, ({ webItems: webItems })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dizL5.LazyForgeUIExtensions), {
                    moduleType: (0, $7Ndnw.FORGE_MODULE_GLOBAL_PAGE),
                    render: (forgeApps, loading, error)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($676e787a42c3de42$var$AppsContentLoader, {
                            // @ts-expect-error FIXME: one of the attributes that is expected down the component tree is not provided, and never was
                            webItems: webItems,
                            forge: {
                                items: error || loading ? [] : forgeApps,
                                loading: loading,
                                error: error
                            }
                        })
                })),
        onOpen: ()=>onClick(true),
        onClose: ()=>onClick(false),
        experienceName: (0, $irVI7.APP_NAV_APPS_DROPDOWN_EXPERIENCE)
    });
});

});
parcelRegister("d5p70", function(module, exports) {

$parcel$export(module.exports, "SPACE_DIRECTORY_KEY", () => $e7a417d1c27c7cb8$export$8fa81f0104234d32);
$parcel$export(module.exports, "PEOPLE_DIRECTORY_KEY", () => $e7a417d1c27c7cb8$export$78f3e9dc1aa1d31d);
$parcel$export(module.exports, "ANALYTICS_MODULE_KEY", () => $e7a417d1c27c7cb8$export$7d83ae3269ed7906);
$parcel$export(module.exports, "ANALYTICS_MODERATE_MODULE_KEY", () => $e7a417d1c27c7cb8$export$bedb5aba2044c670);
$parcel$export(module.exports, "FIND_NEW_APPS_KEY", () => $e7a417d1c27c7cb8$export$26a7b00a59d7901e);
$parcel$export(module.exports, "AUTOMATION_KEY", () => $e7a417d1c27c7cb8$export$ee99bc1ad01a63ae);
const $e7a417d1c27c7cb8$export$8fa81f0104234d32 = 'com.atlassian.confluence.plugins.confluence-space-ia:header-spaces-link';
const $e7a417d1c27c7cb8$export$78f3e9dc1aa1d31d = 'com.atlassian.confluence.plugins.confluence-space-ia:header-people-link';
const $e7a417d1c27c7cb8$export$7d83ae3269ed7906 = 'com.addonengine.analytics__analytics-instance-settings-menu-item-adg3';
const $e7a417d1c27c7cb8$export$bedb5aba2044c670 = 'com.addonengine.analytics.moderate__analytics-instance-settings-menu-item-adg3';
const $e7a417d1c27c7cb8$export$26a7b00a59d7901e = 'com.atlassian.confluence.emcee__enduser-discover';
const $e7a417d1c27c7cb8$export$ee99bc1ad01a63ae = 'com.atlassian.confluence.plugins.confluence-space-ia:header-automation-link';

});

parcelRegister("lX5T4", function(module, exports) {

let $ffb3acbce6a6aaac$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ffb3acbce6a6aaac$var$load("in0CI"),
    $ffb3acbce6a6aaac$var$load("6vzdH"),
    $ffb3acbce6a6aaac$var$load("ffEVr"),
    $ffb3acbce6a6aaac$var$load("joJy8"),
    $ffb3acbce6a6aaac$var$load("aHE9G"),
    $ffb3acbce6a6aaac$var$load("2ZapG")
]).then(()=>parcelRequire('6L739'));

});


parcelRegister("a8e7z", function(module, exports) {

$parcel$export(module.exports, "TemplatesItem", () => $ea88a2fca64b2fa5$export$9e7802a7d1db8cfc);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");

var $inPa6 = parcelRequire("inPa6");

var $dPJCf = parcelRequire("dPJCf");

var $1NBp8 = parcelRequire("1NBp8");

var $lBYCH = parcelRequire("lBYCH");

var $epLE5 = parcelRequire("epLE5");

var $kAra1 = parcelRequire("kAra1");
const $ea88a2fca64b2fa5$var$i18n = (0, $2nPZH.defineMessages)({
    TemplatesLink: {
        id: "app-navigation.templates.link",
        defaultMessage: "Templates"
    }
});

const $ea88a2fca64b2fa5$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("04nCC"))).fireTemplatesClickedAnalytics);
const $ea88a2fca64b2fa5$export$9e7802a7d1db8cfc = /*#__PURE__*/ (0, $gwFzn.memo)(({ testId: testId })=>{
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { resetStickySearchRef: resetStickySearchRef } = (0, $gwFzn.useContext)((0, $lBYCH.AppNavigationContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickedAnalytics = $ea88a2fca64b2fa5$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const onClick = (0, $gwFzn.useCallback)(()=>{
        resetStickySearchRef?.current?.();
        fireClickedAnalytics();
    }, [
        resetStickySearchRef,
        fireClickedAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kAra1.PrimaryItem), {
        testId: testId,
        i18n: $ea88a2fca64b2fa5$var$i18n.TemplatesLink,
        namedRoute: (0, $1NBp8.TEMPLATE_GALLERY),
        onClick: onClick
    });
});

});

parcelRegister("jSBj7", function(module, exports) {

let $e78fffeccfc1b455$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e78fffeccfc1b455$var$load("bVqnE").then(()=>parcelRequire('98wGO'));

});


parcelRegister("egliE", function(module, exports) {

$parcel$export(module.exports, "useNavigationTheme", () => $e130d4fe70478402$export$261caf7a59aaa456);

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $ahT8g = parcelRequire("ahT8g");
var $jeF0t = parcelRequire("jeF0t");

var $dIouf = parcelRequire("dIouf");

var $7Sm4c = parcelRequire("7Sm4c");

var $djivE = parcelRequire("djivE");

var $j5cB3 = parcelRequire("j5cB3");

var $ih4dR = parcelRequire("ih4dR");
const $e130d4fe70478402$export$261caf7a59aaa456 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $djivE.AppNavigationUnifiedQuery));
    if (error && (0, $dIouf.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    const isDarkMode = (0, $j5cB3.useIsDarkMode)();
    const theme = (0, $gwFzn.useMemo)(()=>{
        return loading ? (0, $ahT8g.atlassianTheme) : $e130d4fe70478402$var$generateValidTheme(data, isDarkMode);
    }, [
        loading,
        data,
        isDarkMode
    ]);
    return {
        loading: loading,
        theme: theme
    };
};
const $e130d4fe70478402$var$generateValidTheme = (data, isDarkMode)=>{
    const customTheme = (0, $ih4dR.getCustomTheme)({
        backgroundColorRaw: data?.lookAndFeel?.custom?.horizontalHeader?.backgroundColor,
        highlightColorRaw: data?.lookAndFeel?.custom?.horizontalHeader?.primaryNavigation?.highlightColor,
        isDarkMode: isDarkMode,
        isNav4Enabled: false
    });
    if (!customTheme) return 0, $ahT8g.atlassianTheme;
    return (0, $jeF0t.generateTheme)({
        name: 'theme',
        ...customTheme
    });
};

});

parcelRegister("bnz0d", function(module, exports) {

$parcel$export(module.exports, "ConfluenceProductHome", () => $4dbea263d036481d$export$c6fdbb01da54b025);

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $iOozU = parcelRequire("iOozU");

var $guzTv = parcelRequire("guzTv");
var $cs19m = parcelRequire("cs19m");

var $3XNLY = parcelRequire("3XNLY");
var $heZL9 = parcelRequire("heZL9");

var $gdv5Z = parcelRequire("gdv5Z");

var $c6GJD = parcelRequire("c6GJD");

var $dPJCf = parcelRequire("dPJCf");

var $dIouf = parcelRequire("dIouf");

var $dEBDF = parcelRequire("dEBDF");

var $1NBp8 = parcelRequire("1NBp8");

var $lBYCH = parcelRequire("lBYCH");

var $jmjWc = parcelRequire("jmjWc");

var $8jvvW = parcelRequire("8jvvW");

var $7Sm4c = parcelRequire("7Sm4c");

var $eainP = parcelRequire("eainP");

var $djivE = parcelRequire("djivE");
const $4dbea263d036481d$var$href = (0, $1NBp8.WIKI).toUrl();
const $4dbea263d036481d$var$i18n = (0, $2nPZH.defineMessages)({
    productLinkLabel: {
        id: "app-navigation.product-link.label",
        defaultMessage: "Confluence Home"
    }
});

const $4dbea263d036481d$var$BranchDeployLogoLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "odBca",
    name: "BranchDeployLogoLoader",
    loader: async ()=>(await (parcelRequire("7dkt9"))).BranchDeployLogo,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iOozU))), {
            label: "Loading..."
        })
});

const $4dbea263d036481d$var$FeatureFlagLogoLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6GWsd",
    name: "FeatureFlagLogoLoader",
    loader: async ()=>(await (parcelRequire("25yS1"))).FeatureFlagLogo
});
const $4dbea263d036481d$var$ConfluenceProductHomeBase = ({ ConfluenceLogo: ConfluenceLogo, ConfluenceIcon: ConfluenceIcon })=>{
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { resetStickySearchRef: resetStickySearchRef } = (0, $gwFzn.useContext)((0, $lBYCH.AppNavigationContext));
    const { data: data, loading: loading, error: error } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $djivE.AppNavigationUnifiedQuery));
    const fireAnalytics = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'productLogo',
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navVersion: '3',
                    navdexPointType: (0, $dEBDF.START_TOUCH)
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        routeDataRef
    ]);
    const onClickWithMeta = (e)=>{
        e.preventDefault();
        fireAnalytics();
        resetStickySearchRef?.current?.();
        if (e.metaKey) window.open($4dbea263d036481d$var$href, '_blank', 'noreferrer');
        else push($4dbea263d036481d$var$href);
    };
    if (loading) return null;
    if (error) {
        if ((0, $dIouf.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        throw error;
    }
    const showSiteTitle = data?.siteSettings?.showApplicationTitle;
    const siteTitle = showSiteTitle ? data?.siteSettings?.siteTitle : undefined;
    if (data?.siteConfiguration.customSiteLogo && data?.siteDescription?.logoUrl) {
        const siteLogo = data?.siteDescription?.logoUrl;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3XNLY.default), {
            iconAlt: "Custom icon",
            iconUrl: siteLogo,
            logoAlt: "Custom logo",
            logoUrl: siteLogo,
            href: $4dbea263d036481d$var$href,
            onClick: onClickWithMeta,
            "aria-label": siteTitle,
            siteTitle: siteTitle,
            "data-testid": "app-navigation-custom-wordmark"
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $heZL9.default), {
        icon: ConfluenceIcon,
        logo: ConfluenceLogo,
        siteTitle: siteTitle,
        href: $4dbea263d036481d$var$href,
        "aria-label": formatMessage($4dbea263d036481d$var$i18n.productLinkLabel),
        onClick: onClickWithMeta,
        "data-testid": "app-navigation-wordmark"
    });
};
const $4dbea263d036481d$export$c6fdbb01da54b025 = /*#__PURE__*/ (0, $gwFzn.memo)(()=>{
    const { isBranchDeploy: isBranchDeploy } = (0, $gwFzn.useContext)((0, $lBYCH.AppNavigationContext));
    const featureFlagOverrides = (0, $8jvvW.getOverrides)();
    const featureGateOverrides = (0, $c6GJD.default).getOverrides();
    const hasOverrides = Object.keys(featureFlagOverrides).length > 0 || Object.keys(featureGateOverrides.gates).length > 0 || Object.keys(featureGateOverrides.configs).length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eainP.HomeLogo), {
        "data-testid": "app-navigation-home-logo"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.GenericErrorBoundary), {
        attribution: (0, $dIouf.Attribution).DISCO,
        renderOnError: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $heZL9.default), {
                icon: (0, $guzTv.ConfluenceIcon),
                logo: (0, $cs19m.ConfluenceLogo),
                "data-testid": "app-navigation-wordmark-error"
            })
    }, isBranchDeploy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        paddingInlineEnd: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4dbea263d036481d$var$BranchDeployLogoLoader, null)), hasOverrides && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4dbea263d036481d$var$FeatureFlagLogoLoader, {
        featureFlagOverrides: featureFlagOverrides,
        featureGateOverrides: featureGateOverrides
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4dbea263d036481d$var$ConfluenceProductHomeBase, {
        ConfluenceIcon: (0, $guzTv.ConfluenceIcon),
        ConfluenceLogo: (0, $cs19m.ConfluenceLogo)
    })));
});

});
parcelRegister("3XNLY", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd8cba489a48e146$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $6fnsQ = parcelRequire("6fnsQ");

var $2yFMK = parcelRequire("2yFMK");

var $4qrTW = parcelRequire("4qrTW");

var $6iFTf = parcelRequire("6iFTf");
const $fd8cba489a48e146$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $fd8cba489a48e146$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $fd8cba489a48e146$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $fd8cba489a48e146$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $fd8cba489a48e146$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $fd8cba489a48e146$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $fd8cba489a48e146$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $fd8cba489a48e146$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $fd8cba489a48e146$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $fd8cba489a48e146$var$productLogoStyles = (0, $3jLHL.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $2yFMK.PRODUCT_HOME_BREAKPOINT) - 0.1}px)`]: {
        display: 'none'
    }
});
const $fd8cba489a48e146$var$customMaxHeightStyles = (0, $3jLHL.css)({
    maxHeight: 28
});
const $fd8cba489a48e146$var$productIconStyles = (0, $3jLHL.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $2yFMK.PRODUCT_HOME_BREAKPOINT}px)`]: {
        display: 'none'
    }
});
const $fd8cba489a48e146$var$productHomeButtonStyles = (0, $3jLHL.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:hover': {
        backgroundColor: `var(${$fd8cba489a48e146$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$fd8cba489a48e146$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$fd8cba489a48e146$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    '&:active': {
        backgroundColor: `var(${$fd8cba489a48e146$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$fd8cba489a48e146$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$fd8cba489a48e146$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus-visible': {
        backgroundColor: `var(${$fd8cba489a48e146$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        color: `var(${$fd8cba489a48e146$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: `2px solid ${`var(--ds-border-focused, ${(0, $6fnsQ.B200)})`}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $2yFMK.PRODUCT_HOME_BREAKPOINT) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $2yFMK.PRODUCT_HOME_BREAKPOINT}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $fd8cba489a48e146$var$siteTitleStyles = (0, $3jLHL.css)({
    display: 'flex',
    alignItems: 'center',
    marginInlineEnd: "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-050, 4px)",
    paddingInlineEnd: "var(--ds-space-200, 16px)"
});
/**
 * __Custom product home__
 *
 * Use `CustomProductHome` to provide a custom logo and icon with URLs.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#custom-product-home)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */ const $fd8cba489a48e146$var$CustomProductHome = (props)=>{
    const { href: href, iconAlt: iconAlt, iconUrl: iconUrl, logoAlt: logoAlt, logoMaxWidth: logoMaxWidth = 260, logoUrl: logoUrl, onClick: onClick, onMouseDown: onMouseDown, siteTitle: siteTitle, testId: testId, ...rest } = props;
    const theme = (0, $4qrTW.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    const Tag = (0, $6iFTf.getTag)(onClick, href);
    const preventFocusRing = (event)=>{
        event.preventDefault();
        onMouseDown && onMouseDown(event);
    };
    const productHomeButtonDynamicStyles = {
        [$fd8cba489a48e146$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$fd8cba489a48e146$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$fd8cba489a48e146$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$fd8cba489a48e146$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$fd8cba489a48e146$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$fd8cba489a48e146$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$fd8cba489a48e146$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$fd8cba489a48e146$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$fd8cba489a48e146$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow
    };
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, $3jLHL.jsx)(Tag, {
        href: href,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $fd8cba489a48e146$var$productHomeButtonStyles,
        onClick: onClick,
        onMouseDown: preventFocusRing,
        "data-testid": testId && `${testId}-container`,
        ...rest
    }, logoUrl && /*#__PURE__*/ (0, $3jLHL.jsx)("img", {
        style: {
            maxWidth: logoMaxWidth
        },
        css: [
            $fd8cba489a48e146$var$customMaxHeightStyles,
            $fd8cba489a48e146$var$productLogoStyles
        ],
        src: logoUrl,
        alt: logoAlt,
        "data-testid": testId && `${testId}-logo`,
        "data-vc": "custom-product-home-logo"
    }), iconUrl && /*#__PURE__*/ (0, $3jLHL.jsx)("img", {
        style: {
            maxWidth: logoMaxWidth
        },
        css: [
            $fd8cba489a48e146$var$customMaxHeightStyles,
            $fd8cba489a48e146$var$productIconStyles
        ],
        src: iconUrl,
        alt: iconAlt,
        "data-testid": testId && `${testId}-icon`,
        "data-vc": "custom-product-home-icon"
    })), siteTitle && /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        style: {
            borderRight: theme.mode.productHome.borderRight
        },
        css: $fd8cba489a48e146$var$siteTitleStyles,
        "data-testid": testId && `${testId}-site-title`
    }, siteTitle));
};
var $fd8cba489a48e146$export$2e2bcd8739ae039 = $fd8cba489a48e146$var$CustomProductHome;

});

parcelRegister("7dkt9", function(module, exports) {

let $5409a01042e17161$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $5409a01042e17161$var$load("160SJ"),
    $5409a01042e17161$var$load("bJYtz"),
    $5409a01042e17161$var$load("8dYdP")
]).then(()=>parcelRequire('gef2L'));

});

parcelRegister("25yS1", function(module, exports) {

let $185718e6eb7feed1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $185718e6eb7feed1$var$load("in0CI"),
    $185718e6eb7feed1$var$load("160SJ"),
    $185718e6eb7feed1$var$load("392bg"),
    $185718e6eb7feed1$var$load("joJy8"),
    $185718e6eb7feed1$var$load("aHE9G"),
    $185718e6eb7feed1$var$load("bkswC")
]).then(()=>parcelRequire('lhO3J'));

});


parcelRegister("7pjFz", function(module, exports) {

$parcel$export(module.exports, "LazyAppSwitcher", () => $e7bc3abe69a9b18b$export$4a3b927c290b4310);
$parcel$export(module.exports, "LazyNotifications", () => $e7bc3abe69a9b18b$export$eebecbd0322becdd);
$parcel$export(module.exports, "LazyNotes", () => $e7bc3abe69a9b18b$export$aff9dab8fe8422cd);
$parcel$export(module.exports, "LazySettings", () => $e7bc3abe69a9b18b$export$3b2d7d568ca2b5ce);
$parcel$export(module.exports, "LazyCreate", () => $e7bc3abe69a9b18b$export$9945de3dd3685508);
$parcel$export(module.exports, "LazyHelp", () => $e7bc3abe69a9b18b$export$9181fac880aced4d);
$parcel$export(module.exports, "LazySearch", () => $e7bc3abe69a9b18b$export$964f3f99df662c38);
$parcel$export(module.exports, "LazyProfile", () => $e7bc3abe69a9b18b$export$dae03335d87dc813);
/* appNavigationLazyItems.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $kNHXO = parcelRequire("kNHXO");

var $ckcSY = parcelRequire("ckcSY");

var $ci7Ox = parcelRequire("ci7Ox");

var $8MTIk = parcelRequire("8MTIk");

var $jmjWc = parcelRequire("jmjWc");

var $kPjLK = parcelRequire("kPjLK");

var $gsXbX = parcelRequire("gsXbX");

var $6MlZq = parcelRequire("6MlZq");

var $eainP = parcelRequire("eainP");

var $iGpKB = parcelRequire("iGpKB");

const $e7bc3abe69a9b18b$export$4a3b927c290b4310 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "e7Q6O",
    name: "LazyAppSwitcher",
    loader: async ()=>(await (parcelRequire("3lotx"))).AppSwitcherComponentWrapper,
    loading: ()=>// This placeholder should match the AppSwitcher component from @atlaskit/atlassian-navigation
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8MTIk.IconButton), {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kNHXO))), {
                label: ""
            }),
            tooltip: ""
        }),
    _noPreloadWhenRenderingSPA: true
});
// This placeholder should match the Notifications component from @atlaskit/atlassian-navigation
const $e7bc3abe69a9b18b$var$NotificationsPlaceholder = ()=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
    const Wrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $35pXk.default)([
                "_kqswh2mm",
                __cmplp.className
            ])
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8MTIk.IconButton), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ckcSY))), {
            label: ""
        }),
        tooltip: ""
    }));
};

const $e7bc3abe69a9b18b$export$eebecbd0322becdd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8ZZ_O",
    name: "LazyNotifications",
    loader: async ()=>(await (parcelRequire("165Zb"))).NotificationsComponent,
    loading: $e7bc3abe69a9b18b$var$NotificationsPlaceholder,
    _noPreloadWhenRenderingSPA: true
});

const $e7bc3abe69a9b18b$export$aff9dab8fe8422cd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zT8wD",
    name: "LazyNotes",
    loader: async ()=>(await (parcelRequire("bIgBB"))).NotesComponent,
    loading: ()=>null,
    _noPreloadWhenRenderingSPA: true
});

const $e7bc3abe69a9b18b$export$3b2d7d568ca2b5ce = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6GfZ_",
    name: "LazySettings",
    loader: async ()=>(await (parcelRequire("dMur6"))).SettingsComponent,
    _noPreloadWhenRenderingSPA: true
});
const $e7bc3abe69a9b18b$export$9945de3dd3685508 = ()=>{
    const isCreationDropdownEnabled = (0, $6MlZq.useIsCreationDropdownEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eainP.NavItemWrapper), null, isCreationDropdownEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e7bc3abe69a9b18b$var$LazyGlobalCreatePopover, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e7bc3abe69a9b18b$var$LazyCreateComponent, null));
};

const $e7bc3abe69a9b18b$var$LazyCreateComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "tUu13",
    name: "LazyCreateComponent",
    loader: async ()=>(await (parcelRequire("pWd1M"))).CreateComponent,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iGpKB.CreateButton), null),
    _noPreloadWhenRenderingSPA: true
});

const $e7bc3abe69a9b18b$var$LazyGlobalCreatePopover = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Yidng",
    name: "LazyGlobalCreatePopover",
    loader: async ()=>(await (parcelRequire("pWd1M"))).CreateComponent,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gsXbX.GlobalCreateContentButton), {
            triggerProps: {},
            onClick: ()=>{}
        }),
    _noPreloadWhenRenderingSPA: true
});


const $e7bc3abe69a9b18b$export$9181fac880aced4d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Fyxb1",
    name: "LazyHelp",
    loader: async ()=>{
        const [{ MenuComponent: MenuComponent }, { HelpComponent: HelpComponent }] = await Promise.all([
            (parcelRequire("c2vOs")),
            (parcelRequire("fxfGb"))
        ]);
        return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(MenuComponent, {
                menu: HelpComponent,
                ...props
            });
    },
    loading: ()=>// This placeholder should match the Help component from @atlaskit/atlassian-navigation
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
                ...__cmplp,
                style: __cmpls,
                ref: __cmplr,
                className: (0, $35pXk.default)([
                    "_2hwx1b66",
                    __cmplp.className
                ])
            });
        }), {}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8MTIk.IconButton), {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))), {
                    label: ""
                }),
                tooltip: ""
            }))),
    _noPreloadWhenRenderingSPA: true
});

const $e7bc3abe69a9b18b$export$964f3f99df662c38 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "XpfLQ",
    name: "LazySearch",
    loader: async ()=>(await (parcelRequire("5oL6V"))).SearchComponent,
    loading: ({ theme: theme })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kPjLK.InteractiveSearchInputSkeleton), {
            theme: theme
        }),
    _noPreloadWhenRenderingSPA: true
});


const $e7bc3abe69a9b18b$export$dae03335d87dc813 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "pyvBU",
    name: "LazyProfile",
    loader: async ()=>{
        const [{ MenuComponent: MenuComponent }, { ProfileComponent: ProfileComponent }] = await Promise.all([
            (parcelRequire("c2vOs")),
            (parcelRequire("5oH1Y"))
        ]);
        return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(MenuComponent, {
                menu: ProfileComponent,
                ...props
            });
    },
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
                ...__cmplp,
                style: __cmpls,
                ref: __cmplr,
                className: (0, $35pXk.default)([
                    "_1bsb14no _4t3i14no",
                    __cmplp.className
                ])
            });
        }))
});

});
parcelRegister("3lotx", function(module, exports) {

let $26f65198f161383f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $26f65198f161383f$var$load("6vzdH"),
    $26f65198f161383f$var$load("ifAt9"),
    $26f65198f161383f$var$load("HYlkB"),
    $26f65198f161383f$var$load("eEpXU"),
    $26f65198f161383f$var$load("ggRlL"),
    $26f65198f161383f$var$load("in0CI"),
    $26f65198f161383f$var$load("8B8z5"),
    $26f65198f161383f$var$load("1wN7j"),
    $26f65198f161383f$var$load("aZwOd"),
    $26f65198f161383f$var$load("8yyrA"),
    $26f65198f161383f$var$load("F2Q4u")
]).then(()=>parcelRequire('cI6uD'));

});

parcelRegister("165Zb", function(module, exports) {

let $0ccafe9fc3e3fd1c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $0ccafe9fc3e3fd1c$var$load("28HoJ"),
    $0ccafe9fc3e3fd1c$var$load("in0CI"),
    $0ccafe9fc3e3fd1c$var$load("7TRGL"),
    $0ccafe9fc3e3fd1c$var$load("8xSXV"),
    $0ccafe9fc3e3fd1c$var$load("8yyrA"),
    $0ccafe9fc3e3fd1c$var$load("joJy8"),
    $0ccafe9fc3e3fd1c$var$load("aHE9G"),
    $0ccafe9fc3e3fd1c$var$load("df12q")
]).then(()=>parcelRequire('krs8y'));

});

parcelRegister("bIgBB", function(module, exports) {

let $8870af3ff7888ac1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $8870af3ff7888ac1$var$load("in0CI"),
    $8870af3ff7888ac1$var$load("ffEVr"),
    $8870af3ff7888ac1$var$load("iW7i1")
]).then(()=>parcelRequire('dlbJ7'));

});

parcelRegister("dMur6", function(module, exports) {

let $a0875e07275d7f67$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a0875e07275d7f67$var$load("in0CI"),
    $a0875e07275d7f67$var$load("c5krk"),
    $a0875e07275d7f67$var$load("ffEVr"),
    $a0875e07275d7f67$var$load("heZTL")
]).then(()=>parcelRequire('lCh01'));

});

parcelRegister("pWd1M", function(module, exports) {

let $04df7d08b3daa7c9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $04df7d08b3daa7c9$var$load("in0CI"),
    $04df7d08b3daa7c9$var$load("InrG6"),
    $04df7d08b3daa7c9$var$load("ex7Yl"),
    $04df7d08b3daa7c9$var$load("jqXtk"),
    $04df7d08b3daa7c9$var$load("gkMTK"),
    $04df7d08b3daa7c9$var$load("2BIkk"),
    $04df7d08b3daa7c9$var$load("lJxwk"),
    $04df7d08b3daa7c9$var$load("aGZFn"),
    $04df7d08b3daa7c9$var$load("ifAt9"),
    $04df7d08b3daa7c9$var$load("HYlkB"),
    $04df7d08b3daa7c9$var$load("5aY5g"),
    $04df7d08b3daa7c9$var$load("cLErX"),
    $04df7d08b3daa7c9$var$load("hkGfe"),
    $04df7d08b3daa7c9$var$load("bHPtM"),
    $04df7d08b3daa7c9$var$load("agpqg"),
    $04df7d08b3daa7c9$var$load("gOjQr"),
    $04df7d08b3daa7c9$var$load("9ZY0L"),
    $04df7d08b3daa7c9$var$load("2oVPY"),
    $04df7d08b3daa7c9$var$load("jPS1u"),
    $04df7d08b3daa7c9$var$load("dY7M5"),
    $04df7d08b3daa7c9$var$load("lFp1i"),
    $04df7d08b3daa7c9$var$load("dLkMK"),
    $04df7d08b3daa7c9$var$load("6qah4"),
    $04df7d08b3daa7c9$var$load("aZinD"),
    $04df7d08b3daa7c9$var$load("8yyrA"),
    $04df7d08b3daa7c9$var$load("ffEVr"),
    $04df7d08b3daa7c9$var$load("joJy8"),
    $04df7d08b3daa7c9$var$load("aHE9G"),
    $04df7d08b3daa7c9$var$load("d4MuV")
]).then(()=>parcelRequire('kBOGD'));

});

parcelRegister("c2vOs", function(module, exports) {

let $8c3e594a4d8e11c8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $8c3e594a4d8e11c8$var$load("joJy8"),
    $8c3e594a4d8e11c8$var$load("aHE9G"),
    $8c3e594a4d8e11c8$var$load("6YgN9")
]).then(()=>parcelRequire('6V6D9'));

});

parcelRegister("fxfGb", function(module, exports) {

let $b4f619ad05c411c4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $b4f619ad05c411c4$var$load("in0CI"),
    $b4f619ad05c411c4$var$load("28HoJ"),
    $b4f619ad05c411c4$var$load("ffEVr"),
    $b4f619ad05c411c4$var$load("eXOVv")
]).then(()=>parcelRequire('g7YcF'));

});

parcelRegister("5oL6V", function(module, exports) {

let $3ee3bcdd17e76964$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $3ee3bcdd17e76964$var$load("in0CI"),
    $3ee3bcdd17e76964$var$load("6vzdH"),
    $3ee3bcdd17e76964$var$load("7lGj4"),
    $3ee3bcdd17e76964$var$load("jkTol"),
    $3ee3bcdd17e76964$var$load("fCUFG"),
    $3ee3bcdd17e76964$var$load("eKndM"),
    $3ee3bcdd17e76964$var$load("fOKJ2"),
    $3ee3bcdd17e76964$var$load("d2qwW"),
    $3ee3bcdd17e76964$var$load("4ADTj"),
    $3ee3bcdd17e76964$var$load("4zTgj"),
    $3ee3bcdd17e76964$var$load("eXlRV"),
    $3ee3bcdd17e76964$var$load("fgAxa"),
    $3ee3bcdd17e76964$var$load("bZWqy"),
    $3ee3bcdd17e76964$var$load("9ZY0L"),
    $3ee3bcdd17e76964$var$load("iBm1B"),
    $3ee3bcdd17e76964$var$load("gLxW3"),
    $3ee3bcdd17e76964$var$load("ftJgg"),
    $3ee3bcdd17e76964$var$load("cUIjD"),
    $3ee3bcdd17e76964$var$load("hKqxh"),
    $3ee3bcdd17e76964$var$load("7sseo"),
    $3ee3bcdd17e76964$var$load("cMlHc"),
    $3ee3bcdd17e76964$var$load("fqrMn"),
    $3ee3bcdd17e76964$var$load("eVYW1"),
    $3ee3bcdd17e76964$var$load("fYi1a"),
    $3ee3bcdd17e76964$var$load("ls0Um"),
    $3ee3bcdd17e76964$var$load("bjzRn"),
    $3ee3bcdd17e76964$var$load("020xd"),
    $3ee3bcdd17e76964$var$load("8mzoy"),
    $3ee3bcdd17e76964$var$load("eTBsW"),
    $3ee3bcdd17e76964$var$load("42vdC"),
    $3ee3bcdd17e76964$var$load("1oiJ6"),
    $3ee3bcdd17e76964$var$load("dil5i"),
    $3ee3bcdd17e76964$var$load("2fk6g"),
    $3ee3bcdd17e76964$var$load("hPalR"),
    $3ee3bcdd17e76964$var$load("8059b"),
    $3ee3bcdd17e76964$var$load("kIjBt"),
    $3ee3bcdd17e76964$var$load("3wmvj"),
    $3ee3bcdd17e76964$var$load("fe4be"),
    $3ee3bcdd17e76964$var$load("jDjSj"),
    $3ee3bcdd17e76964$var$load("8DoxJ"),
    $3ee3bcdd17e76964$var$load("aZinD"),
    $3ee3bcdd17e76964$var$load("aQp8v"),
    $3ee3bcdd17e76964$var$load("2jsRt"),
    $3ee3bcdd17e76964$var$load("bEnB5"),
    $3ee3bcdd17e76964$var$load("kjZZD"),
    $3ee3bcdd17e76964$var$load("aGZFn"),
    $3ee3bcdd17e76964$var$load("6qah4"),
    $3ee3bcdd17e76964$var$load("ffEVr"),
    $3ee3bcdd17e76964$var$load("joJy8"),
    $3ee3bcdd17e76964$var$load("aHE9G"),
    $3ee3bcdd17e76964$var$load("01qRE")
]).then(()=>parcelRequire('Cia8R'));

});

parcelRegister("5oH1Y", function(module, exports) {

let $3ee092a58fdca981$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $3ee092a58fdca981$var$load("in0CI"),
    $3ee092a58fdca981$var$load("iMSgb"),
    $3ee092a58fdca981$var$load("bkOZu"),
    $3ee092a58fdca981$var$load("ftJgg"),
    $3ee092a58fdca981$var$load("ffEVr"),
    $3ee092a58fdca981$var$load("joJy8"),
    $3ee092a58fdca981$var$load("aHE9G"),
    $3ee092a58fdca981$var$load("eHw9Y")
]).then(()=>parcelRequire('3JZ3w'));

});




//# sourceMappingURL=AppNavigation.11acffe5.js.map
